import { airloomApi as api } from "./baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    coreViewsIndex: build.query<
      CoreViewsIndexApiResponse,
      CoreViewsIndexApiArg
    >({
      query: () => ({ url: `/api/` }),
    }),
    coreViewsHealth: build.query<
      CoreViewsHealthApiResponse,
      CoreViewsHealthApiArg
    >({
      query: () => ({ url: `/api/health` }),
    }),
    accessLevelsViewsGetAccessLevels: build.query<
      AccessLevelsViewsGetAccessLevelsApiResponse,
      AccessLevelsViewsGetAccessLevelsApiArg
    >({
      query: () => ({ url: `/api/access_levels/` }),
    }),
    automationsViewsCreateAutomation: build.mutation<
      AutomationsViewsCreateAutomationApiResponse,
      AutomationsViewsCreateAutomationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/automations/`,
        method: "POST",
        body: queryArg.createAutomationRuleSchema,
      }),
    }),
    automationsViewsGetAutomation: build.query<
      AutomationsViewsGetAutomationApiResponse,
      AutomationsViewsGetAutomationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/automations/${queryArg.automationId}`,
      }),
    }),
    automationsViewsUpdateAutomation: build.mutation<
      AutomationsViewsUpdateAutomationApiResponse,
      AutomationsViewsUpdateAutomationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/automations/${queryArg.automationId}`,
        method: "PATCH",
        body: queryArg.updateAutomationRuleSchema,
      }),
    }),
    automationsViewsDeleteAutomation: build.mutation<
      AutomationsViewsDeleteAutomationApiResponse,
      AutomationsViewsDeleteAutomationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/automations/${queryArg.automationId}`,
        method: "DELETE",
      }),
    }),
    billingViewsSubscriptionCreatedEvent: build.mutation<
      BillingViewsSubscriptionCreatedEventApiResponse,
      BillingViewsSubscriptionCreatedEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billing/webhooks/subscription-created`,
        method: "POST",
        body: queryArg.subscriptionCreatedInSchema,
      }),
    }),
    billingViewsSubscriptionUpdatedEvent: build.mutation<
      BillingViewsSubscriptionUpdatedEventApiResponse,
      BillingViewsSubscriptionUpdatedEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billing/webhooks/subscription-updated`,
        method: "POST",
        body: queryArg.subscriptionUpdatedInSchema,
      }),
    }),
    billingViewsSubscriptionCancelledEvent: build.mutation<
      BillingViewsSubscriptionCancelledEventApiResponse,
      BillingViewsSubscriptionCancelledEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billing/webhooks/subscription-cancelled`,
        method: "POST",
        body: queryArg.subscriptionDeletedInSchema,
      }),
    }),
    billingViewsInvoicePaymentFailedEvent: build.mutation<
      BillingViewsInvoicePaymentFailedEventApiResponse,
      BillingViewsInvoicePaymentFailedEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billing/webhooks/invoice-payment-failed`,
        method: "POST",
        body: queryArg.invoicePaymentFailedInSchema,
      }),
    }),
    billingViewsInvoicePaymentSucceededEvent: build.mutation<
      BillingViewsInvoicePaymentSucceededEventApiResponse,
      BillingViewsInvoicePaymentSucceededEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billing/webhooks/invoice-payment-succeeded`,
        method: "POST",
        body: queryArg.invoicePaymentSucceededInSchema,
      }),
    }),
    billingViewsGetBillingStatus: build.query<
      BillingViewsGetBillingStatusApiResponse,
      BillingViewsGetBillingStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billing/business/${queryArg.businessId}/status`,
      }),
    }),
    businessesViewsCreateBusiness: build.mutation<
      BusinessesViewsCreateBusinessApiResponse,
      BusinessesViewsCreateBusinessApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/`,
        method: "POST",
        body: queryArg.createBusinessInSchema,
      }),
    }),
    businessesViewsListBusinesses: build.query<
      BusinessesViewsListBusinessesApiResponse,
      BusinessesViewsListBusinessesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/`,
        params: {
          access_level: queryArg.accessLevel,
        },
      }),
    }),
    businessesViewsGetBusinessTypes: build.query<
      BusinessesViewsGetBusinessTypesApiResponse,
      BusinessesViewsGetBusinessTypesApiArg
    >({
      query: () => ({ url: `/api/businesses/types` }),
    }),
    businessesViewsGetBusiness: build.query<
      BusinessesViewsGetBusinessApiResponse,
      BusinessesViewsGetBusinessApiArg
    >({
      query: (queryArg) => ({ url: `/api/businesses/${queryArg.businessId}` }),
    }),
    businessesViewsUpdateBusiness: build.mutation<
      BusinessesViewsUpdateBusinessApiResponse,
      BusinessesViewsUpdateBusinessApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}`,
        method: "PUT",
        body: queryArg.updateBusinessInSchema,
      }),
    }),
    businessesViewsDeleteBusiness: build.mutation<
      BusinessesViewsDeleteBusinessApiResponse,
      BusinessesViewsDeleteBusinessApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}`,
        method: "DELETE",
      }),
    }),
    businessesViewsGetLocationsForBusiness: build.query<
      BusinessesViewsGetLocationsForBusinessApiResponse,
      BusinessesViewsGetLocationsForBusinessApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}/locations`,
      }),
    }),
    businessesViewsCreateBusinessAccessLevel: build.mutation<
      BusinessesViewsCreateBusinessAccessLevelApiResponse,
      BusinessesViewsCreateBusinessAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}/access-levels`,
        method: "POST",
        body: queryArg.createBusinessAccessLevelInSchema,
      }),
    }),
    businessesViewsListBusinessAccessLevels: build.query<
      BusinessesViewsListBusinessAccessLevelsApiResponse,
      BusinessesViewsListBusinessAccessLevelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}/access-levels`,
      }),
    }),
    businessesViewsUpdateBusinessAccessLevel: build.mutation<
      BusinessesViewsUpdateBusinessAccessLevelApiResponse,
      BusinessesViewsUpdateBusinessAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}/access-levels/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.updateBusinessAccessLevelInSchema,
      }),
    }),
    businessesViewsDeleteBusinessAccessLevel: build.mutation<
      BusinessesViewsDeleteBusinessAccessLevelApiResponse,
      BusinessesViewsDeleteBusinessAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}/access-levels/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    businessesViewsCreateCheckoutSession: build.mutation<
      BusinessesViewsCreateCheckoutSessionApiResponse,
      BusinessesViewsCreateCheckoutSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}/billing/checkout-session`,
        method: "POST",
        body: queryArg.createCheckoutSessionInSchema,
      }),
    }),
    businessesViewsResubscribeCheckoutView: build.mutation<
      BusinessesViewsResubscribeCheckoutViewApiResponse,
      BusinessesViewsResubscribeCheckoutViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}/billing/resubscribe-checkout-session`,
        method: "POST",
        body: queryArg.createCheckoutSessionInSchema,
      }),
    }),
    businessesViewsManageView: build.mutation<
      BusinessesViewsManageViewApiResponse,
      BusinessesViewsManageViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/businesses/${queryArg.businessId}/billing/manage-portal`,
        method: "POST",
      }),
    }),
    camerasViewsCreateCamera: build.mutation<
      CamerasViewsCreateCameraApiResponse,
      CamerasViewsCreateCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/`,
        method: "POST",
        body: queryArg.createCameraInSchema,
      }),
    }),
    camerasViewsGetCamera: build.query<
      CamerasViewsGetCameraApiResponse,
      CamerasViewsGetCameraApiArg
    >({
      query: (queryArg) => ({ url: `/api/cameras/${queryArg.cameraId}` }),
    }),
    camerasViewsUpdateCamera: build.mutation<
      CamerasViewsUpdateCameraApiResponse,
      CamerasViewsUpdateCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}`,
        method: "PUT",
        body: queryArg.updateCameraInSchema,
      }),
    }),
    camerasViewsDeleteCamera: build.mutation<
      CamerasViewsDeleteCameraApiResponse,
      CamerasViewsDeleteCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}`,
        method: "DELETE",
      }),
    }),
    camerasViewsCreateCameraClipForCamera: build.mutation<
      CamerasViewsCreateCameraClipForCameraApiResponse,
      CamerasViewsCreateCameraClipForCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/clips`,
        method: "POST",
        body: queryArg.createCameraClipInSchema,
      }),
    }),
    camerasViewsListCameraClipsForCamera: build.query<
      CamerasViewsListCameraClipsForCameraApiResponse,
      CamerasViewsListCameraClipsForCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/clips`,
        params: {
          start_time_epoch: queryArg.startTimeEpoch,
          end_time_epoch: queryArg.endTimeEpoch,
        },
      }),
    }),
    camerasViewsGetCameraStreamUrl: build.query<
      CamerasViewsGetCameraStreamUrlApiResponse,
      CamerasViewsGetCameraStreamUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/stream-url`,
        params: {
          start_time_epoch: queryArg.startTimeEpoch,
          end_time_epoch: queryArg.endTimeEpoch,
        },
      }),
    }),
    camerasViewsGenerateThumbnailForCamera: build.mutation<
      CamerasViewsGenerateThumbnailForCameraApiResponse,
      CamerasViewsGenerateThumbnailForCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/generate-thumbnail`,
        method: "POST",
        body: queryArg.generateThumbnailInSchema,
      }),
    }),
    camerasViewsTestPlaybackForCamera: build.mutation<
      CamerasViewsTestPlaybackForCameraApiResponse,
      CamerasViewsTestPlaybackForCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/test-playback`,
        method: "POST",
        body: queryArg.testPlaybackInSchema,
      }),
    }),
    camerasViewsCreateCameraAccessLevel: build.mutation<
      CamerasViewsCreateCameraAccessLevelApiResponse,
      CamerasViewsCreateCameraAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/access-levels`,
        method: "POST",
        body: queryArg.createCameraAccessLevelInSchema,
      }),
    }),
    camerasViewsListCameraAccessLevels: build.query<
      CamerasViewsListCameraAccessLevelsApiResponse,
      CamerasViewsListCameraAccessLevelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/access-levels`,
      }),
    }),
    camerasViewsUpdateCameraAccessLevel: build.mutation<
      CamerasViewsUpdateCameraAccessLevelApiResponse,
      CamerasViewsUpdateCameraAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/access-levels/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.updateCameraAccessLevelInSchema,
      }),
    }),
    camerasViewsDeleteCameraAccessLevel: build.mutation<
      CamerasViewsDeleteCameraAccessLevelApiResponse,
      CamerasViewsDeleteCameraAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/access-levels/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    camerasViewsCreateObjectForCamera: build.mutation<
      CamerasViewsCreateObjectForCameraApiResponse,
      CamerasViewsCreateObjectForCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/objects`,
        method: "POST",
        body: queryArg.createObjectForCameraInSchema,
      }),
    }),
    camerasViewsListObjectsForCamera: build.query<
      CamerasViewsListObjectsForCameraApiResponse,
      CamerasViewsListObjectsForCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/objects`,
      }),
    }),
    camerasViewsAddExistingObjectToCamera: build.mutation<
      CamerasViewsAddExistingObjectToCameraApiResponse,
      CamerasViewsAddExistingObjectToCameraApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/objects/${queryArg.objectId}`,
        method: "POST",
        body: queryArg.addObjectToCameraInSchema,
      }),
    }),
    camerasViewsDeleteCameraObjectMapping: build.mutation<
      CamerasViewsDeleteCameraObjectMappingApiResponse,
      CamerasViewsDeleteCameraObjectMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/objects/${queryArg.objectId}`,
        method: "DELETE",
      }),
    }),
    camerasViewsUpdateCameraObjectMapping: build.mutation<
      CamerasViewsUpdateCameraObjectMappingApiResponse,
      CamerasViewsUpdateCameraObjectMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cameras/${queryArg.cameraId}/objects/${queryArg.objectId}`,
        method: "PUT",
        body: queryArg.updateCameraObjectMappingInSchema,
      }),
    }),
    connectionsViewsCreateConnection: build.mutation<
      ConnectionsViewsCreateConnectionApiResponse,
      ConnectionsViewsCreateConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/connections/`,
        method: "POST",
        body: queryArg.createConnectionInSchema,
      }),
    }),
    connectionsViewsOauthCallback: build.mutation<
      ConnectionsViewsOauthCallbackApiResponse,
      ConnectionsViewsOauthCallbackApiArg
    >({
      query: (queryArg) => ({
        url: `/api/connections/oauth-callback`,
        method: "POST",
        body: queryArg.oAuthCallbackIn,
      }),
    }),
    connectionsViewsGetAuthUrl: build.query<
      ConnectionsViewsGetAuthUrlApiResponse,
      ConnectionsViewsGetAuthUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/api/connections/auth-url`,
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    connectionsViewsGetConnectionTypes: build.query<
      ConnectionsViewsGetConnectionTypesApiResponse,
      ConnectionsViewsGetConnectionTypesApiArg
    >({
      query: () => ({ url: `/api/connections/types` }),
    }),
    connectionsViewsGetConnection: build.query<
      ConnectionsViewsGetConnectionApiResponse,
      ConnectionsViewsGetConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/connections/${queryArg.connectionId}`,
      }),
    }),
    connectionsViewsUpdateConnection: build.mutation<
      ConnectionsViewsUpdateConnectionApiResponse,
      ConnectionsViewsUpdateConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/connections/${queryArg.connectionId}`,
        method: "PUT",
        body: queryArg.updateConnectionInSchema,
      }),
    }),
    connectionsViewsDeleteConnection: build.mutation<
      ConnectionsViewsDeleteConnectionApiResponse,
      ConnectionsViewsDeleteConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/connections/${queryArg.connectionId}`,
        method: "DELETE",
      }),
    }),
    connectionsViewsCreateAllCamerasForConnection: build.mutation<
      ConnectionsViewsCreateAllCamerasForConnectionApiResponse,
      ConnectionsViewsCreateAllCamerasForConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/connections/${queryArg.connectionId}/cameras`,
        method: "POST",
      }),
    }),
    connectionsViewsListCamerasByConnection: build.query<
      ConnectionsViewsListCamerasByConnectionApiResponse,
      ConnectionsViewsListCamerasByConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/connections/${queryArg.connectionId}/cameras`,
      }),
    }),
    integrationsViewsCreateIntegration: build.mutation<
      IntegrationsViewsCreateIntegrationApiResponse,
      IntegrationsViewsCreateIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/`,
        method: "POST",
        body: queryArg.createIntegrationInSchema,
      }),
    }),
    integrationsViewsGetAuthUrl: build.query<
      IntegrationsViewsGetAuthUrlApiResponse,
      IntegrationsViewsGetAuthUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/auth-url`,
      }),
    }),
    integrationsViewsOauthCallback: build.mutation<
      IntegrationsViewsOauthCallbackApiResponse,
      IntegrationsViewsOauthCallbackApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/oauth-callback`,
        method: "POST",
        body: queryArg.oAuthCallbackInSchema,
      }),
    }),
    integrationsViewsGetIntegrationStatus: build.query<
      IntegrationsViewsGetIntegrationStatusApiResponse,
      IntegrationsViewsGetIntegrationStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/status`,
      }),
    }),
    integrationsViewsGetIntegrationTypes: build.query<
      IntegrationsViewsGetIntegrationTypesApiResponse,
      IntegrationsViewsGetIntegrationTypesApiArg
    >({
      query: () => ({ url: `/api/integrations/types` }),
    }),
    integrationsViewsGetIntegration: build.query<
      IntegrationsViewsGetIntegrationApiResponse,
      IntegrationsViewsGetIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}`,
      }),
    }),
    integrationsViewsUpdateIntegrationConfig: build.mutation<
      IntegrationsViewsUpdateIntegrationConfigApiResponse,
      IntegrationsViewsUpdateIntegrationConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}`,
        method: "PUT",
        body: queryArg.updateIntegrationInSchema,
      }),
    }),
    integrationsViewsDeleteIntegration: build.mutation<
      IntegrationsViewsDeleteIntegrationApiResponse,
      IntegrationsViewsDeleteIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}`,
        method: "DELETE",
      }),
    }),
    integrationsViewsProxyIntegrationRequest: build.mutation<
      IntegrationsViewsProxyIntegrationRequestApiResponse,
      IntegrationsViewsProxyIntegrationRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/proxy`,
        method: "POST",
        body: queryArg.proxyRequestInSchema,
      }),
    }),
    integrationsViewsGetSupportedObjectTypesFromIntegration: build.query<
      IntegrationsViewsGetSupportedObjectTypesFromIntegrationApiResponse,
      IntegrationsViewsGetSupportedObjectTypesFromIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/object-types`,
      }),
    }),
    integrationsViewsGetSupportedEventsFromIntegration: build.query<
      IntegrationsViewsGetSupportedEventsFromIntegrationApiResponse,
      IntegrationsViewsGetSupportedEventsFromIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/supported-events`,
      }),
    }),
    integrationsViewsListAutomationsForIntegration: build.query<
      IntegrationsViewsListAutomationsForIntegrationApiResponse,
      IntegrationsViewsListAutomationsForIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/automations`,
      }),
    }),
    integrationsViewsListSearchesForIntegration: build.mutation<
      IntegrationsViewsListSearchesForIntegrationApiResponse,
      IntegrationsViewsListSearchesForIntegrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/searches/list`,
        method: "POST",
        body: queryArg.listIntegrationSearchesFilterSchema,
      }),
    }),
    integrationsViewsGetIntegrationMappingForSearch: build.query<
      IntegrationsViewsGetIntegrationMappingForSearchApiResponse,
      IntegrationsViewsGetIntegrationMappingForSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/searches/${queryArg.searchId}/mapping`,
      }),
    }),
    integrationsViewsGetBulkSearchMappings: build.mutation<
      IntegrationsViewsGetBulkSearchMappingsApiResponse,
      IntegrationsViewsGetBulkSearchMappingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/searches/bulk-mappings`,
        method: "POST",
        body: queryArg.bulkSearchMappingsInSchema,
      }),
    }),
    integrationsViewsGetMindbodyActivationCode: build.query<
      IntegrationsViewsGetMindbodyActivationCodeApiResponse,
      IntegrationsViewsGetMindbodyActivationCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/mindbody/activation-code`,
      }),
    }),
    integrationsViewsMindbodyIssueToken: build.mutation<
      IntegrationsViewsMindbodyIssueTokenApiResponse,
      IntegrationsViewsMindbodyIssueTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/integrations/${queryArg.integrationId}/mindbody/issue-token`,
        method: "POST",
      }),
    }),
    locationsViewsCreateLocation: build.mutation<
      LocationsViewsCreateLocationApiResponse,
      LocationsViewsCreateLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/`,
        method: "POST",
        body: queryArg.createLocationInSchema,
      }),
    }),
    locationsViewsGetTimezones: build.query<
      LocationsViewsGetTimezonesApiResponse,
      LocationsViewsGetTimezonesApiArg
    >({
      query: () => ({ url: `/api/locations/timezones` }),
    }),
    locationsViewsGetLocation: build.query<
      LocationsViewsGetLocationApiResponse,
      LocationsViewsGetLocationApiArg
    >({
      query: (queryArg) => ({ url: `/api/locations/${queryArg.locationId}` }),
    }),
    locationsViewsUpdateLocation: build.mutation<
      LocationsViewsUpdateLocationApiResponse,
      LocationsViewsUpdateLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}`,
        method: "PUT",
        body: queryArg.updateLocationInSchema,
      }),
    }),
    locationsViewsDeleteLocation: build.mutation<
      LocationsViewsDeleteLocationApiResponse,
      LocationsViewsDeleteLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}`,
        method: "DELETE",
      }),
    }),
    locationsViewsGetCamerasForLocation: build.query<
      LocationsViewsGetCamerasForLocationApiResponse,
      LocationsViewsGetCamerasForLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/cameras`,
      }),
    }),
    locationsViewsGetConnectionsForLocation: build.query<
      LocationsViewsGetConnectionsForLocationApiResponse,
      LocationsViewsGetConnectionsForLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/connections`,
      }),
    }),
    locationsViewsGetIntegrationsForLocation: build.query<
      LocationsViewsGetIntegrationsForLocationApiResponse,
      LocationsViewsGetIntegrationsForLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/integrations`,
      }),
    }),
    locationsViewsListObjectsForLocation: build.query<
      LocationsViewsListObjectsForLocationApiResponse,
      LocationsViewsListObjectsForLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/objects`,
      }),
    }),
    locationsViewsCreateLocationAccessLevel: build.mutation<
      LocationsViewsCreateLocationAccessLevelApiResponse,
      LocationsViewsCreateLocationAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/access-levels`,
        method: "POST",
        body: queryArg.createLocationAccessLevelInSchema,
      }),
    }),
    locationsViewsListLocationAccessLevels: build.query<
      LocationsViewsListLocationAccessLevelsApiResponse,
      LocationsViewsListLocationAccessLevelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/access-levels`,
      }),
    }),
    locationsViewsUpdateLocationAccessLevel: build.mutation<
      LocationsViewsUpdateLocationAccessLevelApiResponse,
      LocationsViewsUpdateLocationAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/access-levels/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.updateLocationAccessLevelInSchema,
      }),
    }),
    locationsViewsDeleteLocationAccessLevel: build.mutation<
      LocationsViewsDeleteLocationAccessLevelApiResponse,
      LocationsViewsDeleteLocationAccessLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/access-levels/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    metricsViewsGetMetricsForTimePeriod: build.query<
      MetricsViewsGetMetricsForTimePeriodApiResponse,
      MetricsViewsGetMetricsForTimePeriodApiArg
    >({
      query: (queryArg) => ({
        url: `/api/modules/metrics/events`,
        params: {
          location_id: queryArg.locationId,
          start_datetime_local: queryArg.startDatetimeLocal,
          end_datetime_local: queryArg.endDatetimeLocal,
          metric_type: queryArg.metricType,
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    metricsViewsGetMetricTypes: build.query<
      MetricsViewsGetMetricTypesApiResponse,
      MetricsViewsGetMetricTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/modules/metrics/types`,
        params: {
          location_id: queryArg.locationId,
        },
      }),
    }),
    metricsViewsDeleteMetricEvent: build.mutation<
      MetricsViewsDeleteMetricEventApiResponse,
      MetricsViewsDeleteMetricEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/modules/metrics/events/${queryArg.eventId}`,
        method: "DELETE",
      }),
    }),
    onboardingViewsRecordAnalyticsEvent: build.mutation<
      OnboardingViewsRecordAnalyticsEventApiResponse,
      OnboardingViewsRecordAnalyticsEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/onboarding/analytics`,
        method: "POST",
        body: queryArg.onboardingAnalyticsInSchema,
      }),
    }),
    searchesViewsCreateSearch: build.mutation<
      SearchesViewsCreateSearchApiResponse,
      SearchesViewsCreateSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/`,
        method: "POST",
        body: queryArg.createSearchSchema,
      }),
    }),
    searchesViewsGetSearchTypes: build.query<
      SearchesViewsGetSearchTypesApiResponse,
      SearchesViewsGetSearchTypesApiArg
    >({
      query: () => ({ url: `/api/searches/types` }),
    }),
    searchesViewsGetSearch: build.query<
      SearchesViewsGetSearchApiResponse,
      SearchesViewsGetSearchApiArg
    >({
      query: (queryArg) => ({ url: `/api/searches/${queryArg.searchId}` }),
    }),
    searchesViewsUpdateSearch: build.mutation<
      SearchesViewsUpdateSearchApiResponse,
      SearchesViewsUpdateSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/${queryArg.searchId}`,
        method: "PATCH",
        body: queryArg.updateSearchSchema,
      }),
    }),
    searchesViewsDeleteSearch: build.mutation<
      SearchesViewsDeleteSearchApiResponse,
      SearchesViewsDeleteSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/${queryArg.searchId}`,
        method: "DELETE",
      }),
    }),
    searchesViewsGetCameraSummary: build.query<
      SearchesViewsGetCameraSummaryApiResponse,
      SearchesViewsGetCameraSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/${queryArg.searchId}/camera-summary`,
      }),
    }),
    searchesViewsGetCameraResults: build.query<
      SearchesViewsGetCameraResultsApiResponse,
      SearchesViewsGetCameraResultsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/${queryArg.searchId}/cameras/${queryArg.cameraId}/results`,
      }),
    }),
    searchesViewsGetFlatResultsList: build.query<
      SearchesViewsGetFlatResultsListApiResponse,
      SearchesViewsGetFlatResultsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/${queryArg.searchId}/flat-results-list`,
      }),
    }),
    searchesViewsCompleteSearch: build.mutation<
      SearchesViewsCompleteSearchApiResponse,
      SearchesViewsCompleteSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/${queryArg.searchId}/complete`,
        method: "POST",
        body: queryArg.completeSearchInSchema,
      }),
    }),
    searchesViewsListSearchesByCameraIds: build.query<
      SearchesViewsListSearchesByCameraIdsApiResponse,
      SearchesViewsListSearchesByCameraIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/list/cameras`,
        params: {
          camera_ids: queryArg.cameraIds,
          search_type: queryArg.searchType,
          created_after: queryArg.createdAfter,
          created_before: queryArg.createdBefore,
          min_result_count: queryArg.minResultCount,
        },
      }),
    }),
    searchResultsViewsAddResults: build.mutation<
      SearchResultsViewsAddResultsApiResponse,
      SearchResultsViewsAddResultsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/${queryArg.searchId}/results`,
        method: "POST",
        body: queryArg.addResultsInSchema,
      }),
    }),
    searchResultsViewsReviewResult: build.mutation<
      SearchResultsViewsReviewResultApiResponse,
      SearchResultsViewsReviewResultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/results/${queryArg.resultId}`,
        method: "PUT",
        body: queryArg.reviewInSchema,
      }),
    }),
    searchResultsViewsDeleteResult: build.mutation<
      SearchResultsViewsDeleteResultApiResponse,
      SearchResultsViewsDeleteResultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/results/${queryArg.resultId}`,
        method: "DELETE",
      }),
    }),
    searchResultsViewsUpdateResultClipUriView: build.mutation<
      SearchResultsViewsUpdateResultClipUriViewApiResponse,
      SearchResultsViewsUpdateResultClipUriViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/results/${queryArg.resultId}/result-clip`,
        method: "PUT",
        body: queryArg.updateResultClipInSchema,
      }),
    }),
    searchResultsViewsUnlinkResultFromParent: build.mutation<
      SearchResultsViewsUnlinkResultFromParentApiResponse,
      SearchResultsViewsUnlinkResultFromParentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/results/${queryArg.resultId}/unlink`,
        method: "PUT",
      }),
    }),
    searchResultsViewsGetLinkedResults: build.query<
      SearchResultsViewsGetLinkedResultsApiResponse,
      SearchResultsViewsGetLinkedResultsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/searches/results/${queryArg.parentResultId}/linked`,
      }),
    }),
    scheduledSearchesViewsCreateScheduledSearchApi: build.mutation<
      ScheduledSearchesViewsCreateScheduledSearchApiApiResponse,
      ScheduledSearchesViewsCreateScheduledSearchApiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/scheduled_searches/`,
        method: "POST",
        body: queryArg.createScheduledSearchSchema,
      }),
    }),
    scheduledSearchesViewsListScheduledSearches: build.query<
      ScheduledSearchesViewsListScheduledSearchesApiResponse,
      ScheduledSearchesViewsListScheduledSearchesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/scheduled_searches/`,
        params: {
          location_id: queryArg.locationId,
          status: queryArg.status,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    scheduledSearchesViewsGetScheduledSearch: build.query<
      ScheduledSearchesViewsGetScheduledSearchApiResponse,
      ScheduledSearchesViewsGetScheduledSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/scheduled_searches/${queryArg.scheduledSearchId}`,
      }),
    }),
    scheduledSearchesViewsUpdateScheduledSearchApi: build.mutation<
      ScheduledSearchesViewsUpdateScheduledSearchApiApiResponse,
      ScheduledSearchesViewsUpdateScheduledSearchApiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/scheduled_searches/${queryArg.scheduledSearchId}`,
        method: "PUT",
        body: queryArg.updateScheduledSearchSchema,
      }),
    }),
    scheduledSearchesViewsDeleteScheduledSearchApi: build.mutation<
      ScheduledSearchesViewsDeleteScheduledSearchApiApiResponse,
      ScheduledSearchesViewsDeleteScheduledSearchApiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/scheduled_searches/${queryArg.scheduledSearchId}`,
        method: "DELETE",
      }),
    }),
    scheduledSearchesViewsPauseScheduledSearchApi: build.mutation<
      ScheduledSearchesViewsPauseScheduledSearchApiApiResponse,
      ScheduledSearchesViewsPauseScheduledSearchApiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/scheduled_searches/${queryArg.scheduledSearchId}/pause`,
        method: "POST",
      }),
    }),
    scheduledSearchesViewsResumeScheduledSearchApi: build.mutation<
      ScheduledSearchesViewsResumeScheduledSearchApiApiResponse,
      ScheduledSearchesViewsResumeScheduledSearchApiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/scheduled_searches/${queryArg.scheduledSearchId}/resume`,
        method: "POST",
      }),
    }),
    staticObjectsViewsGetObjectTypes: build.query<
      StaticObjectsViewsGetObjectTypesApiResponse,
      StaticObjectsViewsGetObjectTypesApiArg
    >({
      query: () => ({ url: `/api/objects/types` }),
    }),
    staticObjectsViewsFindStaticObjectView: build.mutation<
      StaticObjectsViewsFindStaticObjectViewApiResponse,
      StaticObjectsViewsFindStaticObjectViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/objects/find-object`,
        method: "POST",
        body: queryArg.findObjectInSchema,
      }),
    }),
    staticObjectsViewsCreateStaticObjectView: build.mutation<
      StaticObjectsViewsCreateStaticObjectViewApiResponse,
      StaticObjectsViewsCreateStaticObjectViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/objects/`,
        method: "POST",
        body: queryArg.createObjectInSchema,
      }),
    }),
    staticObjectsViewsDeleteStaticObjectView: build.mutation<
      StaticObjectsViewsDeleteStaticObjectViewApiResponse,
      StaticObjectsViewsDeleteStaticObjectViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/objects/${queryArg.objectId}`,
        method: "DELETE",
      }),
    }),
    streamingViewsGetCameraHlsPlaylist: build.query<
      StreamingViewsGetCameraHlsPlaylistApiResponse,
      StreamingViewsGetCameraHlsPlaylistApiArg
    >({
      query: (queryArg) => ({
        url: `/api/streaming/playlist/${queryArg.searchId}/camera/${queryArg.cameraId}`,
      }),
    }),
    streamingViewsGetClipHlsPlaylist: build.query<
      StreamingViewsGetClipHlsPlaylistApiResponse,
      StreamingViewsGetClipHlsPlaylistApiArg
    >({
      query: (queryArg) => ({
        url: `/api/streaming/clip`,
        params: {
          camera_id: queryArg.cameraId,
          start_epoch: queryArg.startEpoch,
          end_epoch: queryArg.endEpoch,
        },
      }),
    }),
    notificationsViewsListNotificationsForUser: build.query<
      NotificationsViewsListNotificationsForUserApiResponse,
      NotificationsViewsListNotificationsForUserApiArg
    >({
      query: () => ({ url: `/api/notifications/` }),
    }),
    usersViewsListUsers: build.query<
      UsersViewsListUsersApiResponse,
      UsersViewsListUsersApiArg
    >({
      query: () => ({ url: `/api/users/` }),
    }),
    usersViewsGetCurrentUser: build.query<
      UsersViewsGetCurrentUserApiResponse,
      UsersViewsGetCurrentUserApiArg
    >({
      query: () => ({ url: `/api/users/me` }),
    }),
    usersViewsUpdateUserView: build.mutation<
      UsersViewsUpdateUserViewApiResponse,
      UsersViewsUpdateUserViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/update/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.updateUserInSchema,
      }),
    }),
    usersViewsOptInUserToNotificationView: build.mutation<
      UsersViewsOptInUserToNotificationViewApiResponse,
      UsersViewsOptInUserToNotificationViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/notifications/${queryArg.userId}/opt-in`,
        method: "POST",
        body: queryArg.changeUserNotificationSchema,
      }),
    }),
    usersViewsOptOutUserFromNotificationView: build.mutation<
      UsersViewsOptOutUserFromNotificationViewApiResponse,
      UsersViewsOptOutUserFromNotificationViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/notifications/${queryArg.userId}/opt-out`,
        method: "POST",
        body: queryArg.changeUserNotificationSchema,
      }),
    }),
    usersViewsCreateZendeskTicketView: build.mutation<
      UsersViewsCreateZendeskTicketViewApiResponse,
      UsersViewsCreateZendeskTicketViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/create-zendesk-ticket`,
        method: "POST",
        body: queryArg.createZendeskTicketInSchema,
      }),
    }),
    usersViewsDeleteUserView: build.mutation<
      UsersViewsDeleteUserViewApiResponse,
      UsersViewsDeleteUserViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    vipDetectionViewsDetectFacesEndpoint: build.mutation<
      VipDetectionViewsDetectFacesEndpointApiResponse,
      VipDetectionViewsDetectFacesEndpointApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/faces/detect`,
        method: "POST",
        body: queryArg.multiPartBodyParams,
      }),
    }),
    vipDetectionViewsGetPersonTags: build.query<
      VipDetectionViewsGetPersonTagsApiResponse,
      VipDetectionViewsGetPersonTagsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/persons/tags/`,
        params: {
          location_id: queryArg.locationId,
        },
      }),
    }),
    vipDetectionViewsCreatePerson: build.mutation<
      VipDetectionViewsCreatePersonApiResponse,
      VipDetectionViewsCreatePersonApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/persons/`,
        method: "POST",
        body: queryArg.createVipPersonInSchema,
      }),
    }),
    vipDetectionViewsListPersons: build.query<
      VipDetectionViewsListPersonsApiResponse,
      VipDetectionViewsListPersonsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/persons/`,
        params: {
          location_id: queryArg.locationId,
        },
      }),
    }),
    vipDetectionViewsUpdatePerson: build.mutation<
      VipDetectionViewsUpdatePersonApiResponse,
      VipDetectionViewsUpdatePersonApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/persons/${queryArg.personId}/`,
        method: "PATCH",
        body: queryArg.updateVipPersonInSchema,
      }),
    }),
    vipDetectionViewsDeletePerson: build.mutation<
      VipDetectionViewsDeletePersonApiResponse,
      VipDetectionViewsDeletePersonApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/persons/${queryArg.personId}/`,
        method: "DELETE",
      }),
    }),
    vipDetectionViewsAddPersonImage: build.mutation<
      VipDetectionViewsAddPersonImageApiResponse,
      VipDetectionViewsAddPersonImageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/persons/${queryArg.personId}/images/`,
        method: "POST",
        body: queryArg.addVipPersonImageInSchema,
      }),
    }),
    vipDetectionViewsListPersonImages: build.query<
      VipDetectionViewsListPersonImagesApiResponse,
      VipDetectionViewsListPersonImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/persons/${queryArg.personId}/images/`,
      }),
    }),
    vipDetectionViewsDeletePersonImage: build.mutation<
      VipDetectionViewsDeletePersonImageApiResponse,
      VipDetectionViewsDeletePersonImageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/persons/${queryArg.personId}/images/${queryArg.imageId}/`,
        method: "DELETE",
      }),
    }),
    vipDetectionViewsDeleteEvent: build.mutation<
      VipDetectionViewsDeleteEventApiResponse,
      VipDetectionViewsDeleteEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/events/${queryArg.eventId}/`,
        method: "DELETE",
      }),
    }),
    vipDetectionViewsListDetections: build.query<
      VipDetectionViewsListDetectionsApiResponse,
      VipDetectionViewsListDetectionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/detections/`,
        params: {
          location_id: queryArg.locationId,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          person_id: queryArg.personId,
          camera_id: queryArg.cameraId,
          detected_after: queryArg.detectedAfter,
          detected_before: queryArg.detectedBefore,
          min_confidence: queryArg.minConfidence,
          tags: queryArg.tags,
        },
      }),
    }),
    vipDetectionViewsListFaceReviews: build.query<
      VipDetectionViewsListFaceReviewsApiResponse,
      VipDetectionViewsListFaceReviewsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/face-reviews/`,
        params: {
          location_id: queryArg.locationId,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          detected_after: queryArg.detectedAfter,
          detected_before: queryArg.detectedBefore,
          min_det_score: queryArg.minDetScore,
          camera_id: queryArg.cameraId,
          has_candidates: queryArg.hasCandidates,
        },
      }),
    }),
    vipDetectionViewsDeleteFaceReview: build.mutation<
      VipDetectionViewsDeleteFaceReviewApiResponse,
      VipDetectionViewsDeleteFaceReviewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/face-reviews/${queryArg.reviewId}/`,
        method: "DELETE",
      }),
    }),
    vipDetectionViewsRunEnrollmentAudit: build.mutation<
      VipDetectionViewsRunEnrollmentAuditApiResponse,
      VipDetectionViewsRunEnrollmentAuditApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/enrollment-audit/run`,
        method: "POST",
        params: {
          location_id: queryArg.locationId,
        },
      }),
    }),
    vipDetectionViewsGetEnrollmentAuditResult: build.query<
      VipDetectionViewsGetEnrollmentAuditResultApiResponse,
      VipDetectionViewsGetEnrollmentAuditResultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/vip-detection/enrollment-audit/result/${queryArg.taskId}`,
      }),
    }),
    webhooksViewsMindbodyWebhookHead: build.mutation<
      WebhooksViewsMindbodyWebhookHeadApiResponse,
      WebhooksViewsMindbodyWebhookHeadApiArg
    >({
      query: () => ({ url: `/api/webhooks/mindbody`, method: "HEAD" }),
    }),
    webhooksViewsMindbodyWebhook: build.mutation<
      WebhooksViewsMindbodyWebhookApiResponse,
      WebhooksViewsMindbodyWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/api/webhooks/mindbody`,
        method: "POST",
        body: queryArg.mindbodyWebhookSchema,
      }),
    }),
    webhooksViewsVerkadaWebhook: build.mutation<
      WebhooksViewsVerkadaWebhookApiResponse,
      WebhooksViewsVerkadaWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/api/webhooks/verkada`,
        method: "POST",
        body: queryArg.verkadaWebhookSchema,
      }),
    }),
    webhooksViewsToastOrdersWebhook: build.mutation<
      WebhooksViewsToastOrdersWebhookApiResponse,
      WebhooksViewsToastOrdersWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/api/webhooks/toast/orders`,
        method: "POST",
        body: queryArg.toastOrdersWebhookSchema,
      }),
    }),
    webhooksViewsConfigureToastWebhook: build.mutation<
      WebhooksViewsConfigureToastWebhookApiResponse,
      WebhooksViewsConfigureToastWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/api/webhooks/toast/configure`,
        method: "POST",
        body: queryArg.toastWebhookConfigSchema,
      }),
    }),
    webhooksViewsGetToastWebhookStatus: build.query<
      WebhooksViewsGetToastWebhookStatusApiResponse,
      WebhooksViewsGetToastWebhookStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/webhooks/toast/status`,
        params: {
          integration_id: queryArg.integrationId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as airloomApi };
export type CoreViewsIndexApiResponse = /** status 200 OK */ SuccessOutSchema;
export type CoreViewsIndexApiArg = void;
export type CoreViewsHealthApiResponse = /** status 200 OK */ SuccessOutSchema;
export type CoreViewsHealthApiArg = void;
export type AccessLevelsViewsGetAccessLevelsApiResponse =
  /** status 200 OK */ AccessLevelsOutSchema;
export type AccessLevelsViewsGetAccessLevelsApiArg = void;
export type AutomationsViewsCreateAutomationApiResponse =
  /** status 201 Created */ AutomationRuleOutSchema;
export type AutomationsViewsCreateAutomationApiArg = {
  createAutomationRuleSchema: CreateAutomationRuleSchema;
};
export type AutomationsViewsGetAutomationApiResponse =
  /** status 200 OK */ AutomationRuleOutSchema;
export type AutomationsViewsGetAutomationApiArg = {
  automationId: string;
};
export type AutomationsViewsUpdateAutomationApiResponse =
  /** status 200 OK */ AutomationRuleOutSchema;
export type AutomationsViewsUpdateAutomationApiArg = {
  automationId: string;
  updateAutomationRuleSchema: UpdateAutomationRuleSchema;
};
export type AutomationsViewsDeleteAutomationApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type AutomationsViewsDeleteAutomationApiArg = {
  automationId: string;
};
export type BillingViewsSubscriptionCreatedEventApiResponse =
  /** status 200 OK */ WebhookSuccessOutSchema;
export type BillingViewsSubscriptionCreatedEventApiArg = {
  subscriptionCreatedInSchema: SubscriptionCreatedInSchema;
};
export type BillingViewsSubscriptionUpdatedEventApiResponse =
  /** status 200 OK */ WebhookSuccessOutSchema;
export type BillingViewsSubscriptionUpdatedEventApiArg = {
  subscriptionUpdatedInSchema: SubscriptionUpdatedInSchema;
};
export type BillingViewsSubscriptionCancelledEventApiResponse =
  /** status 200 OK */ WebhookSuccessOutSchema;
export type BillingViewsSubscriptionCancelledEventApiArg = {
  subscriptionDeletedInSchema: SubscriptionDeletedInSchema;
};
export type BillingViewsInvoicePaymentFailedEventApiResponse =
  /** status 200 OK */ WebhookSuccessOutSchema;
export type BillingViewsInvoicePaymentFailedEventApiArg = {
  invoicePaymentFailedInSchema: InvoicePaymentFailedInSchema;
};
export type BillingViewsInvoicePaymentSucceededEventApiResponse =
  /** status 200 OK */ WebhookSuccessOutSchema;
export type BillingViewsInvoicePaymentSucceededEventApiArg = {
  invoicePaymentSucceededInSchema: InvoicePaymentSucceededInSchema;
};
export type BillingViewsGetBillingStatusApiResponse =
  /** status 200 OK */ BillingStatusOutSchema;
export type BillingViewsGetBillingStatusApiArg = {
  businessId: string;
};
export type BusinessesViewsCreateBusinessApiResponse =
  /** status 201 Created */ BusinessOutSchema;
export type BusinessesViewsCreateBusinessApiArg = {
  createBusinessInSchema: CreateBusinessInSchema;
};
export type BusinessesViewsListBusinessesApiResponse =
  /** status 200 OK */ ListBusinessesOutSchema;
export type BusinessesViewsListBusinessesApiArg = {
  accessLevel?: string | null;
};
export type BusinessesViewsGetBusinessTypesApiResponse =
  /** status 200 OK */ BusinessTypesOutSchema;
export type BusinessesViewsGetBusinessTypesApiArg = void;
export type BusinessesViewsGetBusinessApiResponse =
  /** status 200 OK */ BusinessOutSchema;
export type BusinessesViewsGetBusinessApiArg = {
  businessId: string;
};
export type BusinessesViewsUpdateBusinessApiResponse =
  /** status 200 OK */ BusinessOutSchema;
export type BusinessesViewsUpdateBusinessApiArg = {
  businessId: string;
  updateBusinessInSchema: UpdateBusinessInSchema;
};
export type BusinessesViewsDeleteBusinessApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type BusinessesViewsDeleteBusinessApiArg = {
  businessId: string;
};
export type BusinessesViewsGetLocationsForBusinessApiResponse =
  /** status 200 OK */ ListLocationsOutSchema;
export type BusinessesViewsGetLocationsForBusinessApiArg = {
  businessId: string;
};
export type BusinessesViewsCreateBusinessAccessLevelApiResponse =
  /** status 201 Created */ BusinessAccessLevelOutSchema;
export type BusinessesViewsCreateBusinessAccessLevelApiArg = {
  businessId: string;
  createBusinessAccessLevelInSchema: CreateBusinessAccessLevelInSchema;
};
export type BusinessesViewsListBusinessAccessLevelsApiResponse =
  /** status 200 OK */ ListBusinessAccessLevelsOutSchema;
export type BusinessesViewsListBusinessAccessLevelsApiArg = {
  businessId: string;
};
export type BusinessesViewsUpdateBusinessAccessLevelApiResponse =
  /** status 200 OK */ BusinessAccessLevelOutSchema;
export type BusinessesViewsUpdateBusinessAccessLevelApiArg = {
  businessId: string;
  userId: string;
  updateBusinessAccessLevelInSchema: UpdateBusinessAccessLevelInSchema;
};
export type BusinessesViewsDeleteBusinessAccessLevelApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type BusinessesViewsDeleteBusinessAccessLevelApiArg = {
  businessId: string;
  userId: string;
};
export type BusinessesViewsCreateCheckoutSessionApiResponse =
  /** status 200 OK */ StripeCheckoutSessionOutSchema;
export type BusinessesViewsCreateCheckoutSessionApiArg = {
  businessId: string;
  createCheckoutSessionInSchema: CreateCheckoutSessionInSchema;
};
export type BusinessesViewsResubscribeCheckoutViewApiResponse =
  /** status 200 OK */ StripeCheckoutSessionOutSchema;
export type BusinessesViewsResubscribeCheckoutViewApiArg = {
  businessId: string;
  createCheckoutSessionInSchema: CreateCheckoutSessionInSchema;
};
export type BusinessesViewsManageViewApiResponse =
  /** status 200 OK */ StripeCheckoutSessionOutSchema;
export type BusinessesViewsManageViewApiArg = {
  businessId: string;
};
export type CamerasViewsCreateCameraApiResponse =
  /** status 201 Created */ CameraOutSchema;
export type CamerasViewsCreateCameraApiArg = {
  createCameraInSchema: CreateCameraInSchema;
};
export type CamerasViewsGetCameraApiResponse =
  /** status 200 OK */ CameraOutSchema;
export type CamerasViewsGetCameraApiArg = {
  cameraId: string;
};
export type CamerasViewsUpdateCameraApiResponse =
  /** status 200 OK */ CameraOutSchema;
export type CamerasViewsUpdateCameraApiArg = {
  cameraId: string;
  updateCameraInSchema: UpdateCameraInSchema;
};
export type CamerasViewsDeleteCameraApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type CamerasViewsDeleteCameraApiArg = {
  cameraId: string;
};
export type CamerasViewsCreateCameraClipForCameraApiResponse =
  /** status 201 Created */ CreateCameraClipOutSchema;
export type CamerasViewsCreateCameraClipForCameraApiArg = {
  cameraId: string;
  createCameraClipInSchema: CreateCameraClipInSchema;
};
export type CamerasViewsListCameraClipsForCameraApiResponse =
  /** status 200 OK */ ListCameraClipsOutSchema;
export type CamerasViewsListCameraClipsForCameraApiArg = {
  cameraId: string;
  startTimeEpoch: number;
  endTimeEpoch: number;
};
export type CamerasViewsGetCameraStreamUrlApiResponse =
  /** status 200 OK */ GetCameraStreamUrlOutSchema;
export type CamerasViewsGetCameraStreamUrlApiArg = {
  cameraId: string;
  startTimeEpoch: number;
  endTimeEpoch: number;
};
export type CamerasViewsGenerateThumbnailForCameraApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type CamerasViewsGenerateThumbnailForCameraApiArg = {
  cameraId: string;
  generateThumbnailInSchema: GenerateThumbnailInSchema;
};
export type CamerasViewsTestPlaybackForCameraApiResponse =
  /** status 200 OK */ TestPlaybackOutSchema;
export type CamerasViewsTestPlaybackForCameraApiArg = {
  cameraId: string;
  testPlaybackInSchema: TestPlaybackInSchema;
};
export type CamerasViewsCreateCameraAccessLevelApiResponse =
  /** status 201 Created */ CameraAccessLevelOutSchema;
export type CamerasViewsCreateCameraAccessLevelApiArg = {
  cameraId: string;
  createCameraAccessLevelInSchema: CreateCameraAccessLevelInSchema;
};
export type CamerasViewsListCameraAccessLevelsApiResponse =
  /** status 200 OK */ ListCameraAccessLevelsOutSchema;
export type CamerasViewsListCameraAccessLevelsApiArg = {
  cameraId: string;
};
export type CamerasViewsUpdateCameraAccessLevelApiResponse =
  /** status 200 OK */ CameraAccessLevelOutSchema;
export type CamerasViewsUpdateCameraAccessLevelApiArg = {
  cameraId: string;
  userId: string;
  updateCameraAccessLevelInSchema: UpdateCameraAccessLevelInSchema;
};
export type CamerasViewsDeleteCameraAccessLevelApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type CamerasViewsDeleteCameraAccessLevelApiArg = {
  cameraId: string;
  userId: string;
};
export type CamerasViewsCreateObjectForCameraApiResponse =
  /** status 201 Created */ ObjectOutSchema;
export type CamerasViewsCreateObjectForCameraApiArg = {
  cameraId: string;
  createObjectForCameraInSchema: CreateObjectForCameraInSchema;
};
export type CamerasViewsListObjectsForCameraApiResponse =
  /** status 200 OK */ ListObjectOutSchema;
export type CamerasViewsListObjectsForCameraApiArg = {
  cameraId: string;
};
export type CamerasViewsAddExistingObjectToCameraApiResponse =
  /** status 201 Created */ SuccessOutSchema;
export type CamerasViewsAddExistingObjectToCameraApiArg = {
  cameraId: string;
  objectId: string;
  addObjectToCameraInSchema: AddObjectToCameraInSchema;
};
export type CamerasViewsDeleteCameraObjectMappingApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type CamerasViewsDeleteCameraObjectMappingApiArg = {
  cameraId: string;
  objectId: string;
};
export type CamerasViewsUpdateCameraObjectMappingApiResponse =
  /** status 200 OK */ ObjectOutSchema;
export type CamerasViewsUpdateCameraObjectMappingApiArg = {
  cameraId: string;
  objectId: string;
  updateCameraObjectMappingInSchema: UpdateCameraObjectMappingInSchema;
};
export type ConnectionsViewsCreateConnectionApiResponse =
  /** status 201 Created */ ConnectionOutSchema;
export type ConnectionsViewsCreateConnectionApiArg = {
  createConnectionInSchema: CreateConnectionInSchema;
};
export type ConnectionsViewsOauthCallbackApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type ConnectionsViewsOauthCallbackApiArg = {
  oAuthCallbackIn: OAuthCallbackIn;
};
export type ConnectionsViewsGetAuthUrlApiResponse =
  /** status 200 OK */ GetAuthUrlOutSchema;
export type ConnectionsViewsGetAuthUrlApiArg = {
  type: string;
};
export type ConnectionsViewsGetConnectionTypesApiResponse =
  /** status 200 OK */ ConnectionTypesOutSchema;
export type ConnectionsViewsGetConnectionTypesApiArg = void;
export type ConnectionsViewsGetConnectionApiResponse =
  /** status 200 OK */ ConnectionOutSchema;
export type ConnectionsViewsGetConnectionApiArg = {
  connectionId: string;
};
export type ConnectionsViewsUpdateConnectionApiResponse =
  /** status 200 OK */ ConnectionOutSchema;
export type ConnectionsViewsUpdateConnectionApiArg = {
  connectionId: string;
  updateConnectionInSchema: UpdateConnectionInSchema;
};
export type ConnectionsViewsDeleteConnectionApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type ConnectionsViewsDeleteConnectionApiArg = {
  connectionId: string;
};
export type ConnectionsViewsCreateAllCamerasForConnectionApiResponse =
  /** status 200 OK */ ListCamerasOutSchema;
export type ConnectionsViewsCreateAllCamerasForConnectionApiArg = {
  connectionId: string;
};
export type ConnectionsViewsListCamerasByConnectionApiResponse =
  /** status 200 OK */ ListCamerasOutSchema;
export type ConnectionsViewsListCamerasByConnectionApiArg = {
  connectionId: string;
};
export type IntegrationsViewsCreateIntegrationApiResponse =
  /** status 201 Created */ IntegrationOutSchema;
export type IntegrationsViewsCreateIntegrationApiArg = {
  createIntegrationInSchema: CreateIntegrationInSchema;
};
export type IntegrationsViewsGetAuthUrlApiResponse =
  /** status 200 OK */ GetAuthUrlOutSchema;
export type IntegrationsViewsGetAuthUrlApiArg = {
  integrationId: string;
};
export type IntegrationsViewsOauthCallbackApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type IntegrationsViewsOauthCallbackApiArg = {
  oAuthCallbackInSchema: OAuthCallbackInSchema;
};
export type IntegrationsViewsGetIntegrationStatusApiResponse =
  /** status 200 OK */ IntegrationStatusOutSchema;
export type IntegrationsViewsGetIntegrationStatusApiArg = {
  integrationId: string;
};
export type IntegrationsViewsGetIntegrationTypesApiResponse =
  /** status 200 OK */ IntegrationTypesOutSchema;
export type IntegrationsViewsGetIntegrationTypesApiArg = void;
export type IntegrationsViewsGetIntegrationApiResponse =
  /** status 200 OK */ IntegrationOutSchema;
export type IntegrationsViewsGetIntegrationApiArg = {
  integrationId: string;
};
export type IntegrationsViewsUpdateIntegrationConfigApiResponse =
  /** status 200 OK */ IntegrationOutSchema;
export type IntegrationsViewsUpdateIntegrationConfigApiArg = {
  integrationId: string;
  updateIntegrationInSchema: UpdateIntegrationInSchema;
};
export type IntegrationsViewsDeleteIntegrationApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type IntegrationsViewsDeleteIntegrationApiArg = {
  integrationId: string;
};
export type IntegrationsViewsProxyIntegrationRequestApiResponse =
  /** status 200 OK */ ProxyResponseOutSchema;
export type IntegrationsViewsProxyIntegrationRequestApiArg = {
  integrationId: string;
  proxyRequestInSchema: ProxyRequestInSchema;
};
export type IntegrationsViewsGetSupportedObjectTypesFromIntegrationApiResponse =
  /** status 200 OK */ IntegrationObjectTypesOutSchema;
export type IntegrationsViewsGetSupportedObjectTypesFromIntegrationApiArg = {
  integrationId: string;
};
export type IntegrationsViewsGetSupportedEventsFromIntegrationApiResponse =
  /** status 200 OK */ IntegrationEventTypesOutSchema;
export type IntegrationsViewsGetSupportedEventsFromIntegrationApiArg = {
  integrationId: string;
};
export type IntegrationsViewsListAutomationsForIntegrationApiResponse =
  /** status 200 OK */ ListAutomationRuleOutSchema;
export type IntegrationsViewsListAutomationsForIntegrationApiArg = {
  integrationId: string;
};
export type IntegrationsViewsListSearchesForIntegrationApiResponse =
  /** status 200 OK */ ListIntegrationSearchesOutSchema;
export type IntegrationsViewsListSearchesForIntegrationApiArg = {
  integrationId: string;
  listIntegrationSearchesFilterSchema: ListIntegrationSearchesFilterSchema;
};
export type IntegrationsViewsGetIntegrationMappingForSearchApiResponse =
  /** status 200 OK */ IntegrationMappingOutSchema;
export type IntegrationsViewsGetIntegrationMappingForSearchApiArg = {
  searchId: string;
};
export type IntegrationsViewsGetBulkSearchMappingsApiResponse =
  /** status 200 OK */ BulkSearchMappingsOutSchema;
export type IntegrationsViewsGetBulkSearchMappingsApiArg = {
  bulkSearchMappingsInSchema: BulkSearchMappingsInSchema;
};
export type IntegrationsViewsGetMindbodyActivationCodeApiResponse =
  /** status 200 OK */ MindbodyActivationCodeOutSchema;
export type IntegrationsViewsGetMindbodyActivationCodeApiArg = {
  integrationId: string;
};
export type IntegrationsViewsMindbodyIssueTokenApiResponse =
  /** status 200 OK */ MindbodyIssueTokenOutSchema;
export type IntegrationsViewsMindbodyIssueTokenApiArg = {
  integrationId: string;
};
export type LocationsViewsCreateLocationApiResponse =
  /** status 201 Created */ LocationOutSchema;
export type LocationsViewsCreateLocationApiArg = {
  createLocationInSchema: CreateLocationInSchema;
};
export type LocationsViewsGetTimezonesApiResponse =
  /** status 200 OK */ TimezonesOutSchema;
export type LocationsViewsGetTimezonesApiArg = void;
export type LocationsViewsGetLocationApiResponse =
  /** status 200 OK */ LocationOutSchema;
export type LocationsViewsGetLocationApiArg = {
  locationId: string;
};
export type LocationsViewsUpdateLocationApiResponse =
  /** status 200 OK */ LocationOutSchema;
export type LocationsViewsUpdateLocationApiArg = {
  locationId: string;
  updateLocationInSchema: UpdateLocationInSchema;
};
export type LocationsViewsDeleteLocationApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type LocationsViewsDeleteLocationApiArg = {
  locationId: string;
};
export type LocationsViewsGetCamerasForLocationApiResponse =
  /** status 200 OK */ ListCamerasOutSchema;
export type LocationsViewsGetCamerasForLocationApiArg = {
  locationId: string;
};
export type LocationsViewsGetConnectionsForLocationApiResponse =
  /** status 200 OK */ ListConnectionsOutSchema;
export type LocationsViewsGetConnectionsForLocationApiArg = {
  locationId: string;
};
export type LocationsViewsGetIntegrationsForLocationApiResponse =
  /** status 200 OK */ ListIntegrationsOutSchema;
export type LocationsViewsGetIntegrationsForLocationApiArg = {
  locationId: string;
};
export type LocationsViewsListObjectsForLocationApiResponse =
  /** status 200 OK */ ListObjectOutSchema;
export type LocationsViewsListObjectsForLocationApiArg = {
  locationId: string;
};
export type LocationsViewsCreateLocationAccessLevelApiResponse =
  /** status 201 Created */ LocationAccessLevelOutSchema;
export type LocationsViewsCreateLocationAccessLevelApiArg = {
  locationId: string;
  createLocationAccessLevelInSchema: CreateLocationAccessLevelInSchema;
};
export type LocationsViewsListLocationAccessLevelsApiResponse =
  /** status 200 OK */ ListLocationAccessLevelsOutSchema;
export type LocationsViewsListLocationAccessLevelsApiArg = {
  locationId: string;
};
export type LocationsViewsUpdateLocationAccessLevelApiResponse =
  /** status 200 OK */ LocationAccessLevelOutSchema;
export type LocationsViewsUpdateLocationAccessLevelApiArg = {
  locationId: string;
  userId: string;
  updateLocationAccessLevelInSchema: UpdateLocationAccessLevelInSchema;
};
export type LocationsViewsDeleteLocationAccessLevelApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type LocationsViewsDeleteLocationAccessLevelApiArg = {
  locationId: string;
  userId: string;
};
export type MetricsViewsGetMetricsForTimePeriodApiResponse =
  /** status 200 OK */ AggregateMetricEventsOutSchema;
export type MetricsViewsGetMetricsForTimePeriodApiArg = {
  locationId: string;
  startDatetimeLocal: string;
  endDatetimeLocal: string;
  metricType: string;
  page?: number;
  pageSize?: number;
};
export type MetricsViewsGetMetricTypesApiResponse =
  /** status 200 OK */ MetricTypesOutSchema;
export type MetricsViewsGetMetricTypesApiArg = {
  locationId: string;
};
export type MetricsViewsDeleteMetricEventApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type MetricsViewsDeleteMetricEventApiArg = {
  eventId: string;
};
export type OnboardingViewsRecordAnalyticsEventApiResponse =
  /** status 201 Created */ OnboardingAnalyticsOutSchema;
export type OnboardingViewsRecordAnalyticsEventApiArg = {
  onboardingAnalyticsInSchema: OnboardingAnalyticsInSchema;
};
export type SearchesViewsCreateSearchApiResponse =
  /** status 201 Created */ CreateSearchOutSchema;
export type SearchesViewsCreateSearchApiArg = {
  createSearchSchema: CreateSearchSchema;
};
export type SearchesViewsGetSearchTypesApiResponse =
  /** status 200 OK */ SearchTypesOutSchema;
export type SearchesViewsGetSearchTypesApiArg = void;
export type SearchesViewsGetSearchApiResponse = /** status 200 OK */
  | SearchOutSchema
  | /** status 201 Created */ SearchOutSchema
  | /** status 202 Accepted */ SearchOutSchema
  | /** status 203 Non-Authoritative Information */ SearchOutSchema
  | /** status 204 No Content */ SearchOutSchema
  | /** status 205 Reset Content */ SearchOutSchema
  | /** status 206 Partial Content */ SearchOutSchema;
export type SearchesViewsGetSearchApiArg = {
  searchId: string;
};
export type SearchesViewsUpdateSearchApiResponse =
  /** status 200 OK */ SearchOutSchema;
export type SearchesViewsUpdateSearchApiArg = {
  searchId: string;
  updateSearchSchema: UpdateSearchSchema;
};
export type SearchesViewsDeleteSearchApiResponse =
  /** status 204 No Content */ SuccessOutSchema;
export type SearchesViewsDeleteSearchApiArg = {
  searchId: string;
};
export type SearchesViewsGetCameraSummaryApiResponse = /** status 200 OK */
  | CameraSummaryOutSchema
  | /** status 201 Created */ CameraSummaryOutSchema
  | /** status 202 Accepted */ CameraSummaryOutSchema
  | /** status 203 Non-Authoritative Information */ CameraSummaryOutSchema
  | /** status 204 No Content */ CameraSummaryOutSchema
  | /** status 205 Reset Content */ CameraSummaryOutSchema
  | /** status 206 Partial Content */ CameraSummaryOutSchema;
export type SearchesViewsGetCameraSummaryApiArg = {
  searchId: string;
};
export type SearchesViewsGetCameraResultsApiResponse = /** status 200 OK */
  | CameraResultsOutSchema
  | /** status 201 Created */ CameraResultsOutSchema
  | /** status 202 Accepted */ CameraResultsOutSchema
  | /** status 203 Non-Authoritative Information */ CameraResultsOutSchema
  | /** status 204 No Content */ CameraResultsOutSchema
  | /** status 205 Reset Content */ CameraResultsOutSchema
  | /** status 206 Partial Content */ CameraResultsOutSchema;
export type SearchesViewsGetCameraResultsApiArg = {
  searchId: string;
  cameraId: string;
};
export type SearchesViewsGetFlatResultsListApiResponse = /** status 200 OK */
  | FlatResultsListOutSchema
  | /** status 201 Created */ FlatResultsListOutSchema
  | /** status 202 Accepted */ FlatResultsListOutSchema
  | /** status 203 Non-Authoritative Information */ FlatResultsListOutSchema
  | /** status 204 No Content */ FlatResultsListOutSchema
  | /** status 205 Reset Content */ FlatResultsListOutSchema
  | /** status 206 Partial Content */ FlatResultsListOutSchema;
export type SearchesViewsGetFlatResultsListApiArg = {
  searchId: string;
};
export type SearchesViewsCompleteSearchApiResponse = /** status 200 OK */
  | SuccessOutSchema
  | /** status 201 Created */ SuccessOutSchema
  | /** status 202 Accepted */ SuccessOutSchema
  | /** status 203 Non-Authoritative Information */ SuccessOutSchema
  | /** status 204 No Content */ SuccessOutSchema
  | /** status 205 Reset Content */ SuccessOutSchema
  | /** status 206 Partial Content */ SuccessOutSchema;
export type SearchesViewsCompleteSearchApiArg = {
  searchId: string;
  completeSearchInSchema: CompleteSearchInSchema;
};
export type SearchesViewsListSearchesByCameraIdsApiResponse =
  /** status 200 OK */ ListSearchOutSchema;
export type SearchesViewsListSearchesByCameraIdsApiArg = {
  cameraIds?: string[] | null;
  searchType?: string | null;
  createdAfter?: string | null;
  createdBefore?: string | null;
  minResultCount?: number | null;
};
export type SearchResultsViewsAddResultsApiResponse =
  /** status 201 Created */ SuccessOutSchema;
export type SearchResultsViewsAddResultsApiArg = {
  searchId: string;
  addResultsInSchema: AddResultsInSchema;
};
export type SearchResultsViewsReviewResultApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type SearchResultsViewsReviewResultApiArg = {
  resultId: string;
  reviewInSchema: ReviewInSchema;
};
export type SearchResultsViewsDeleteResultApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type SearchResultsViewsDeleteResultApiArg = {
  resultId: string;
};
export type SearchResultsViewsUpdateResultClipUriViewApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type SearchResultsViewsUpdateResultClipUriViewApiArg = {
  resultId: string;
  updateResultClipInSchema: UpdateResultClipInSchema;
};
export type SearchResultsViewsUnlinkResultFromParentApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type SearchResultsViewsUnlinkResultFromParentApiArg = {
  resultId: string;
};
export type SearchResultsViewsGetLinkedResultsApiResponse =
  /** status 200 OK */
    | SearchResultsOutSchema
    | /** status 201 Created */ SearchResultsOutSchema
    | /** status 202 Accepted */ SearchResultsOutSchema
    | /** status 203 Non-Authoritative Information */ SearchResultsOutSchema
    | /** status 204 No Content */ SearchResultsOutSchema
    | /** status 205 Reset Content */ SearchResultsOutSchema
    | /** status 206 Partial Content */ SearchResultsOutSchema;
export type SearchResultsViewsGetLinkedResultsApiArg = {
  parentResultId: string;
};
export type ScheduledSearchesViewsCreateScheduledSearchApiApiResponse =
  /** status 201 Created */ CreateScheduledSearchOutSchema;
export type ScheduledSearchesViewsCreateScheduledSearchApiApiArg = {
  createScheduledSearchSchema: CreateScheduledSearchSchema;
};
export type ScheduledSearchesViewsListScheduledSearchesApiResponse =
  /** status 200 OK */ ListScheduledSearchesOutSchema;
export type ScheduledSearchesViewsListScheduledSearchesApiArg = {
  locationId?: string | null;
  status?: string | null;
  limit?: number;
  offset?: number;
};
export type ScheduledSearchesViewsGetScheduledSearchApiResponse =
  /** status 200 OK */
    | ScheduledSearchOutSchema
    | /** status 201 Created */ ScheduledSearchOutSchema
    | /** status 202 Accepted */ ScheduledSearchOutSchema
    | /** status 203 Non-Authoritative Information */ ScheduledSearchOutSchema
    | /** status 204 No Content */ ScheduledSearchOutSchema
    | /** status 205 Reset Content */ ScheduledSearchOutSchema
    | /** status 206 Partial Content */ ScheduledSearchOutSchema;
export type ScheduledSearchesViewsGetScheduledSearchApiArg = {
  scheduledSearchId: string;
};
export type ScheduledSearchesViewsUpdateScheduledSearchApiApiResponse =
  /** status 200 OK */
    | ScheduledSearchOutSchema
    | /** status 201 Created */ ScheduledSearchOutSchema
    | /** status 202 Accepted */ ScheduledSearchOutSchema
    | /** status 203 Non-Authoritative Information */ ScheduledSearchOutSchema
    | /** status 204 No Content */ ScheduledSearchOutSchema
    | /** status 205 Reset Content */ ScheduledSearchOutSchema
    | /** status 206 Partial Content */ ScheduledSearchOutSchema;
export type ScheduledSearchesViewsUpdateScheduledSearchApiApiArg = {
  scheduledSearchId: string;
  updateScheduledSearchSchema: UpdateScheduledSearchSchema;
};
export type ScheduledSearchesViewsDeleteScheduledSearchApiApiResponse =
  /** status 204 No Content */ SuccessOutSchema;
export type ScheduledSearchesViewsDeleteScheduledSearchApiApiArg = {
  scheduledSearchId: string;
};
export type ScheduledSearchesViewsPauseScheduledSearchApiApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type ScheduledSearchesViewsPauseScheduledSearchApiApiArg = {
  scheduledSearchId: string;
};
export type ScheduledSearchesViewsResumeScheduledSearchApiApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type ScheduledSearchesViewsResumeScheduledSearchApiApiArg = {
  scheduledSearchId: string;
};
export type StaticObjectsViewsGetObjectTypesApiResponse =
  /** status 200 OK */ ObjectTypesOutSchema;
export type StaticObjectsViewsGetObjectTypesApiArg = void;
export type StaticObjectsViewsFindStaticObjectViewApiResponse =
  /** status 200 OK */ ObjectOutSchema;
export type StaticObjectsViewsFindStaticObjectViewApiArg = {
  findObjectInSchema: FindObjectInSchema;
};
export type StaticObjectsViewsCreateStaticObjectViewApiResponse =
  /** status 201 Created */ ObjectOutSchema;
export type StaticObjectsViewsCreateStaticObjectViewApiArg = {
  createObjectInSchema: CreateObjectInSchema;
};
export type StaticObjectsViewsDeleteStaticObjectViewApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type StaticObjectsViewsDeleteStaticObjectViewApiArg = {
  objectId: string;
};
export type StreamingViewsGetCameraHlsPlaylistApiResponse =
  /** status 200 OK */
    | HlsPlaylistOutSchema
    | /** status 201 Created */ HlsPlaylistOutSchema
    | /** status 202 Accepted */ HlsPlaylistOutSchema
    | /** status 203 Non-Authoritative Information */ HlsPlaylistOutSchema
    | /** status 204 No Content */ HlsPlaylistOutSchema
    | /** status 205 Reset Content */ HlsPlaylistOutSchema
    | /** status 206 Partial Content */ HlsPlaylistOutSchema;
export type StreamingViewsGetCameraHlsPlaylistApiArg = {
  searchId: string;
  cameraId: string;
};
export type StreamingViewsGetClipHlsPlaylistApiResponse = /** status 200 OK */
  | HlsPlaylistOutSchema
  | /** status 201 Created */ HlsPlaylistOutSchema
  | /** status 202 Accepted */ HlsPlaylistOutSchema
  | /** status 203 Non-Authoritative Information */ HlsPlaylistOutSchema
  | /** status 204 No Content */ HlsPlaylistOutSchema
  | /** status 205 Reset Content */ HlsPlaylistOutSchema
  | /** status 206 Partial Content */ HlsPlaylistOutSchema;
export type StreamingViewsGetClipHlsPlaylistApiArg = {
  cameraId: string;
  startEpoch: number;
  endEpoch: number;
};
export type NotificationsViewsListNotificationsForUserApiResponse =
  /** status 200 OK */ ListNotificationOutSchema;
export type NotificationsViewsListNotificationsForUserApiArg = void;
export type UsersViewsListUsersApiResponse =
  /** status 200 OK */ ListUsersOutSchema;
export type UsersViewsListUsersApiArg = void;
export type UsersViewsGetCurrentUserApiResponse =
  /** status 200 OK */ GetUserOutSchema;
export type UsersViewsGetCurrentUserApiArg = void;
export type UsersViewsUpdateUserViewApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type UsersViewsUpdateUserViewApiArg = {
  userId: string;
  updateUserInSchema: UpdateUserInSchema;
};
export type UsersViewsOptInUserToNotificationViewApiResponse =
  /** status 200 OK */
    | SuccessOutSchema
    | /** status 201 Created */ SuccessOutSchema
    | /** status 202 Accepted */ SuccessOutSchema
    | /** status 203 Non-Authoritative Information */ SuccessOutSchema
    | /** status 204 No Content */ SuccessOutSchema
    | /** status 205 Reset Content */ SuccessOutSchema
    | /** status 206 Partial Content */ SuccessOutSchema;
export type UsersViewsOptInUserToNotificationViewApiArg = {
  userId: string;
  changeUserNotificationSchema: ChangeUserNotificationSchema;
};
export type UsersViewsOptOutUserFromNotificationViewApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type UsersViewsOptOutUserFromNotificationViewApiArg = {
  userId: string;
  changeUserNotificationSchema: ChangeUserNotificationSchema;
};
export type UsersViewsCreateZendeskTicketViewApiResponse =
  /** status 201 Created */ CreateZendeskTicketOutSchema;
export type UsersViewsCreateZendeskTicketViewApiArg = {
  createZendeskTicketInSchema: CreateZendeskTicketInSchema;
};
export type UsersViewsDeleteUserViewApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type UsersViewsDeleteUserViewApiArg = {
  userId: string;
};
export type VipDetectionViewsDetectFacesEndpointApiResponse =
  /** status 200 OK */ DetectFacesOutSchema;
export type VipDetectionViewsDetectFacesEndpointApiArg = {
  multiPartBodyParams: {
    location_id: string;
    image: Blob;
  };
};
export type VipDetectionViewsGetPersonTagsApiResponse =
  /** status 200 OK */ PersonTagsOutSchema;
export type VipDetectionViewsGetPersonTagsApiArg = {
  locationId: string;
};
export type VipDetectionViewsCreatePersonApiResponse =
  /** status 201 Created */ VipPersonOutSchema;
export type VipDetectionViewsCreatePersonApiArg = {
  createVipPersonInSchema: CreateVipPersonInSchema;
};
export type VipDetectionViewsListPersonsApiResponse =
  /** status 200 OK */ VipPersonsListOutSchema;
export type VipDetectionViewsListPersonsApiArg = {
  locationId: string;
};
export type VipDetectionViewsUpdatePersonApiResponse =
  /** status 200 OK */ VipPersonOutSchema;
export type VipDetectionViewsUpdatePersonApiArg = {
  personId: string;
  updateVipPersonInSchema: UpdateVipPersonInSchema;
};
export type VipDetectionViewsDeletePersonApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type VipDetectionViewsDeletePersonApiArg = {
  personId: string;
};
export type VipDetectionViewsAddPersonImageApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type VipDetectionViewsAddPersonImageApiArg = {
  personId: string;
  addVipPersonImageInSchema: AddVipPersonImageInSchema;
};
export type VipDetectionViewsListPersonImagesApiResponse =
  /** status 200 OK */ VipPersonImagesOutSchema;
export type VipDetectionViewsListPersonImagesApiArg = {
  personId: string;
};
export type VipDetectionViewsDeletePersonImageApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type VipDetectionViewsDeletePersonImageApiArg = {
  personId: string;
  imageId: string;
};
export type VipDetectionViewsDeleteEventApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type VipDetectionViewsDeleteEventApiArg = {
  eventId: string;
};
export type VipDetectionViewsListDetectionsApiResponse =
  /** status 200 OK */ VipDetectionsListOutSchema;
export type VipDetectionViewsListDetectionsApiArg = {
  locationId: string;
  page?: number;
  pageSize?: number;
  personId?: string;
  cameraId?: string;
  detectedAfter?: string;
  detectedBefore?: string;
  minConfidence?: number;
  tags?: string[];
};
export type VipDetectionViewsListFaceReviewsApiResponse =
  /** status 200 OK */ PendingFaceReviewsListOutSchema;
export type VipDetectionViewsListFaceReviewsApiArg = {
  locationId: string;
  page?: number;
  pageSize?: number;
  detectedAfter?: string;
  detectedBefore?: string;
  minDetScore?: number;
  cameraId?: string;
  hasCandidates?: boolean;
};
export type VipDetectionViewsDeleteFaceReviewApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type VipDetectionViewsDeleteFaceReviewApiArg = {
  reviewId: string;
};
export type VipDetectionViewsRunEnrollmentAuditApiResponse =
  /** status 200 OK */ EnrollmentAuditRunOutSchema;
export type VipDetectionViewsRunEnrollmentAuditApiArg = {
  locationId: string;
};
export type VipDetectionViewsGetEnrollmentAuditResultApiResponse =
  /** status 200 OK */ EnrollmentAuditResultOutSchema;
export type VipDetectionViewsGetEnrollmentAuditResultApiArg = {
  taskId: string;
};
export type WebhooksViewsMindbodyWebhookHeadApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type WebhooksViewsMindbodyWebhookHeadApiArg = void;
export type WebhooksViewsMindbodyWebhookApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type WebhooksViewsMindbodyWebhookApiArg = {
  mindbodyWebhookSchema: MindbodyWebhookSchema;
};
export type WebhooksViewsVerkadaWebhookApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type WebhooksViewsVerkadaWebhookApiArg = {
  verkadaWebhookSchema: VerkadaWebhookSchema;
};
export type WebhooksViewsToastOrdersWebhookApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type WebhooksViewsToastOrdersWebhookApiArg = {
  toastOrdersWebhookSchema: ToastOrdersWebhookSchema;
};
export type WebhooksViewsConfigureToastWebhookApiResponse =
  /** status 200 OK */ SuccessOutSchema;
export type WebhooksViewsConfigureToastWebhookApiArg = {
  toastWebhookConfigSchema: ToastWebhookConfigSchema;
};
export type WebhooksViewsGetToastWebhookStatusApiResponse =
  /** status 200 OK */ ToastWebhookStatusSchema;
export type WebhooksViewsGetToastWebhookStatusApiArg = {
  integrationId: string;
};
export type SuccessOutSchema = {
  success?: boolean;
  message?: string | null;
};
export type AccessLevelSchema = {
  name: string;
  can_read?: boolean;
  can_write?: boolean;
  can_delete?: boolean;
};
export type AccessLevelsOutSchema = {
  success?: boolean;
  message?: string | null;
  access_levels: AccessLevelSchema[];
};
export type AutomationRuleSchema = {
  id: string;
  integration_id: string | null;
  /** User-friendly name for this automation */
  name: string;
  enabled?: boolean;
  /** Optional module type (e.g., TAILGATING). Each integration can only have one automation rule per module type. */
  module_type?: string | null;
  /** Type of event that triggers this automation */
  trigger_type?: string;
  /** Specific event type (e.g., 'appointment.created' for MindBody webhooks) */
  event_type?: string | null;
  /** Integration-specific filters (e.g., {'staff_ids': ['123'], 'room_ids': ['Room 3']}) */
  entity_filters?: object | null;
  /** List of time windows when rule is active: [{'days_of_week': [...], 'start_time': 'HH:MM', 'end_time': 'HH:MM'}] */
  time_windows?: object | null;
  /** Type of action to perform when rule triggers */
  action_type?: string;
  /** Action-specific settings (e.g., for CREATE_SEARCH: camera_ids, query, notification_type, etc.) */
  action_config?: object | null;
  created_at: string;
  updated_at: string;
};
export type AutomationRuleOutSchema = {
  success?: boolean;
  message?: string | null;
  automation_rule: AutomationRuleSchema;
};
export type FailedOutSchema = {
  success?: boolean;
  message?: string | null;
};
export type TimeWindowSchema = {
  days_of_week: string[];
  start_time: string;
  end_time: string;
};
export type SearchActionConfigSchema = {
  query?: string | null;
  lookback_minutes?: number | null;
  duration_minutes?: number | null;
  camera_ids?: string[] | null;
  camera_zones?: any[] | null;
  disable_notifications?: boolean | null;
  notification_type?: string | null;
  notification_emails?: string[] | null;
};
export type CreateAutomationRuleSchema = {
  name: string;
  event_type: string;
  time_windows: TimeWindowSchema[];
  action_config: SearchActionConfigSchema;
  integration_id?: string | null;
  entity_filters?: {
    [key: string]: any;
  };
  enabled?: boolean;
  module_type?: string | null;
};
export type UpdateAutomationRuleSchema = {
  name?: string | null;
  enabled?: boolean | null;
  module_type?: string | null;
  time_windows?: TimeWindowSchema[] | null;
  action_config?: SearchActionConfigSchema | null;
  entity_filters?: {
    [key: string]: any;
  } | null;
};
export type WebhookSuccessOutSchema = {
  success?: boolean;
  message?: string | null;
  processed?: boolean;
};
export type SubscriptionCreatedInSchema = {
  stripe_customer_id: string;
  subscription_id: string;
  subscription_status: string;
  subscription_data: {
    [key: string]: any;
  };
};
export type SubscriptionUpdatedInSchema = {
  stripe_customer_id: string;
  subscription_id: string;
  subscription_data: {
    [key: string]: any;
  };
};
export type SubscriptionDeletedInSchema = {
  stripe_customer_id: string;
  subscription_id: string;
  subscription_data: {
    [key: string]: any;
  };
};
export type InvoicePaymentFailedInSchema = {
  stripe_customer_id: string;
  subscription_id?: string | null;
  amount_due: number;
  currency: string;
  attempt_count: number;
};
export type InvoicePaymentSucceededInSchema = {
  stripe_customer_id: string;
  subscription_id?: string | null;
  amount_paid: number;
  currency: string;
  invoice_id: string;
};
export type BillingSchema = {
  is_paid?: boolean | null;
  paid_location_count?: number;
};
export type BillingStatusOutSchema = {
  success?: boolean;
  message?: string | null;
  billing: BillingSchema;
  has_billing_account: boolean;
  subscription_status: string;
};
export type BusinessSchema = {
  id: string;
  is_paid: boolean;
  name: string;
  type?: string | null;
  created_at: string;
};
export type BusinessOutSchema = {
  success?: boolean;
  message?: string | null;
  business: BusinessSchema;
};
export type CreateBusinessInSchema = {
  name: string;
  type?: string | null;
};
export type ListBusinessesOutSchema = {
  success?: boolean;
  message?: string | null;
  businesses: BusinessSchema[];
};
export type BusinessTypesOutSchema = {
  success?: boolean;
  message?: string | null;
  business_types: [string, string][];
};
export type UpdateBusinessInSchema = {
  name: string;
  type?: string | null;
};
export type LocationSchema = {
  id: string;
  business_id: string;
  name: string;
  region: string;
  timezone: string;
  shifts?: object | null;
};
export type ListLocationsOutSchema = {
  success?: boolean;
  message?: string | null;
  locations: LocationSchema[];
};
export type BusinessAccessLevelSchema = {
  user_id: string;
  user_email: string;
  business_name: string;
  access_level_name: string;
};
export type BusinessAccessLevelOutSchema = {
  success?: boolean;
  message?: string | null;
  business_access_level: BusinessAccessLevelSchema;
};
export type CreateBusinessAccessLevelInSchema = {
  user_email: string;
  access_level_name: string;
  cascade_to_children?: boolean;
};
export type ListBusinessAccessLevelsOutSchema = {
  success?: boolean;
  message?: string | null;
  business_access_levels: BusinessAccessLevelSchema[];
};
export type UpdateBusinessAccessLevelInSchema = {
  access_level_name: string;
  cascade_to_children?: boolean;
};
export type StripeCheckoutSessionOutSchema = {
  success?: boolean;
  message?: string | null;
  url: string;
};
export type CreateCheckoutSessionInSchema = {
  price_id: string;
  location_count?: number;
  is_user_onboarding?: boolean;
};
export type ConnectionSchema = {
  id: string;
  location_id: string;
  name: string;
  type: string;
  config?: object;
};
export type CameraSchema = {
  id: string;
  location_id: string;
  connection: ConnectionSchema;
  thumbnail_url: string | null;
  name: string;
  reference_id: string;
};
export type CameraOutSchema = {
  success?: boolean;
  message?: string | null;
  camera: CameraSchema;
};
export type OAuthConfigInput = {};
export type RtspConfigInput = {
  ip_address: string;
  rtsp_port: string;
  username: string;
  password: string;
};
export type VerkadaConfigInput = {
  stream_api_key: string;
  read_api_key: string;
  organization_id: string;
};
export type OpenEyeConfigInput = {
  tenant_id: string;
  username?: string;
  password?: string;
  device_id?: string | null;
};
export type ReolinkConfigInput = {
  ip_address: string;
  username: string;
  password: string;
  http_port: string;
  https_port: string;
  rtmp_port: string;
  rtsp_port: string;
};
export type CreateConnectionInSchema = {
  name: string;
  location_id: string;
  type: string;
  config:
    | OAuthConfigInput
    | RtspConfigInput
    | VerkadaConfigInput
    | OpenEyeConfigInput
    | ReolinkConfigInput;
};
export type CreateCameraInSchema = {
  name: string;
  reference_id: string;
  location_id: string;
  connection_id?: string | null;
  connection?: CreateConnectionInSchema | null;
};
export type UpdateCameraInSchema = {
  name?: string | null;
  reference_id?: string | null;
};
export type CameraClipSchema = {
  id: string;
  camera_id: string;
  start_time: string;
  end_time: string;
  uri: string;
  hls_segment_uri?: string | null;
};
export type CreateCameraClipOutSchema = {
  success?: boolean;
  message?: string | null;
  camera_clip: CameraClipSchema;
};
export type CreateCameraClipInSchema = {
  start_time_epoch: number;
  end_time_epoch: number;
  uri: string;
  hls_segment_uri?: string | null;
};
export type ListCameraClipsOutSchema = {
  success?: boolean;
  message?: string | null;
  clips: CameraClipSchema[];
};
export type GetCameraStreamUrlOutSchema = {
  success?: boolean;
  message?: string | null;
  stream_url: string;
};
export type GenerateThumbnailInSchema = {
  date?: string | null;
  time?: string | null;
};
export type TestPlaybackOutSchema = {
  success?: boolean;
  message?: string | null;
  camera_id: string;
  playback_image_url: string;
};
export type TestPlaybackInSchema = {
  date: string;
  time: string;
};
export type CameraAccessLevelSchema = {
  user_id: string;
  user_email: string;
  camera_id: string;
  access_level_name: string;
};
export type CameraAccessLevelOutSchema = {
  success?: boolean;
  message?: string | null;
  camera_access_level: CameraAccessLevelSchema;
};
export type CreateCameraAccessLevelInSchema = {
  user_email: string;
  access_level_name: string;
};
export type ListCameraAccessLevelsOutSchema = {
  success?: boolean;
  message?: string | null;
  camera_access_levels: CameraAccessLevelSchema[];
};
export type UpdateCameraAccessLevelInSchema = {
  access_level_name: string;
};
export type CameraObjectMappingSchema = {
  id: string;
  camera_id: string;
  static_object_id: string;
  zone_points?: object;
  visibility_score?: number;
  created_at: string;
};
export type StaticObjectSchema = {
  id: string;
  location_id: string;
  camera_names: string[];
  camera_mappings: CameraObjectMappingSchema[];
  name: string;
  object_type: string;
  description?: string | null;
  created_at: string;
};
export type ObjectOutSchema = {
  success?: boolean;
  message?: string | null;
  object: StaticObjectSchema;
};
export type Point = {
  x: number;
  y: number;
};
export type CreateObjectForCameraInSchema = {
  name: string;
  object_type: string;
  description?: string;
  zone_points: Point[];
};
export type ListObjectOutSchema = {
  success?: boolean;
  message?: string | null;
  objects: StaticObjectSchema[];
};
export type AddObjectToCameraInSchema = {
  zone_points: Point[];
  visibility_score?: number | null;
};
export type UpdateCameraObjectMappingInSchema = {
  zone_points: Point[];
  visibility_score?: number | null;
};
export type ConnectionOutSchema = {
  success?: boolean;
  message?: string | null;
  connection: ConnectionSchema;
  implements_camera_discovery: boolean;
};
export type OAuthCallbackIn = {
  connection_id: string;
  code: string;
};
export type GetAuthUrlOutSchema = {
  success?: boolean;
  message?: string | null;
  auth_url: string;
};
export type ConnectionTypesOutSchema = {
  success?: boolean;
  message?: string | null;
  connection_types: [string, string][];
};
export type UpdateConnectionInSchema = {
  name?: string | null;
  config?: {
    [key: string]: any;
  } | null;
};
export type ListCamerasOutSchema = {
  success?: boolean;
  message?: string | null;
  cameras: CameraSchema[];
};
export type IntegrationSchema = {
  id: string;
  location_id: string;
  name: string;
  type: string;
  config?: object;
  is_active?: boolean;
  created_at: string;
};
export type IntegrationOutSchema = {
  success?: boolean;
  message?: string | null;
  integration: IntegrationSchema;
};
export type OAuthIntegrationConfigInput = {
  api_hostname: string;
  client_id: string;
  client_secret: string;
};
export type ApiKeyIntegrationConfigInput = {
  api_key: string;
};
export type ToastConfigInput = {
  api_hostname: string;
  client_id: string;
  client_secret: string;
  location_external_id: string;
};
export type MindbodyConfigInput = {
  site_id: string;
};
export type CreateIntegrationInSchema = {
  name: string;
  location_id: string;
  type: string;
  config:
    | OAuthIntegrationConfigInput
    | ApiKeyIntegrationConfigInput
    | ToastConfigInput
    | MindbodyConfigInput;
};
export type OAuthCallbackInSchema = {
  integration_id: string;
  code: string;
};
export type IntegrationStatusOutSchema = {
  success?: boolean;
  message?: string | null;
  authenticated: boolean;
  expires_at?: string | null;
  requires_refresh?: boolean;
};
export type IntegrationTypesOutSchema = {
  success?: boolean;
  message?: string | null;
  integration_types: [string, string][];
};
export type UpdateIntegrationInSchema = {
  config: {
    [key: string]: any;
  };
};
export type ProxyResponseOutSchema = {
  success?: boolean;
  message?: string | null;
  status_code: number;
  data?:
    | {
        [key: string]: any;
      }
    | any[]
    | string
    | null;
  headers?: {
    [key: string]: any;
  };
};
export type ProxyRequestInSchema = {
  endpoint: string;
  method?: string;
  params?: {
    [key: string]: any;
  };
  data?:
    | {
        [key: string]: any;
      }
    | any[]
    | string
    | null;
};
export type IntegrationObjectTypeSchema = {
  value: string;
  label: string;
  endpoint: string | null;
};
export type IntegrationObjectTypesOutSchema = {
  success?: boolean;
  message?: string | null;
  object_types: IntegrationObjectTypeSchema[];
};
export type IntegrationEventTypeSchema = {
  value: string;
  label: string;
  description?: string;
  entity_filters_supported?: string[];
};
export type IntegrationEventTypesOutSchema = {
  success?: boolean;
  message?: string | null;
  event_types: IntegrationEventTypeSchema[];
};
export type ListAutomationRuleOutSchema = {
  success?: boolean;
  message?: string | null;
  automation_rules: AutomationRuleSchema[];
};
export type CameraZone = {
  camera_id: string;
  points: Point[];
};
export type SearchSchema = {
  id: string;
  camera_details: {
    [key: string]: string;
  }[];
  result_count: number;
  location: LocationSchema;
  schedule_id: string | null;
  automation_rule_id: string | null;
  camera_zones: CameraZone[] | null;
  notification_type_name: string | null;
  notification_emails: string[];
  query?: string | null;
  search_type?: string;
  created_at: string;
  completed_at?: string | null;
  search_status?: string;
  start_time: string;
  end_time: string;
  camera_ids?: object;
};
export type IntegrationSearchMappingSchema = {
  id: string;
  integration_id: string;
  search_id: string;
  row_identifier: object;
  integration_data?: object | null;
  created_at: string;
};
export type IntegrationSearchItem = {
  search_id: string;
  search: SearchSchema;
  mapping: IntegrationSearchMappingSchema;
};
export type ListIntegrationSearchesOutSchema = {
  success?: boolean;
  message?: string | null;
  search_mappings: IntegrationSearchItem[];
};
export type ListIntegrationSearchesFilterSchema = {
  created_after?: string | null;
  created_before?: string | null;
  row_identifier_filter?: {
    [key: string]: any;
  } | null;
  limit?: number;
  offset?: number;
};
export type IntegrationMappingOutSchema = {
  success?: boolean;
  message?: string | null;
  mapping: IntegrationSearchMappingSchema;
};
export type BulkSearchMappingsOutSchema = {
  success?: boolean;
  message?: string | null;
  mappings: {
    [key: string]: IntegrationSearchMappingSchema;
  };
};
export type BulkSearchMappingsInSchema = {
  search_ids: string[];
};
export type MindbodyActivationCodeOutSchema = {
  success?: boolean;
  message?: string | null;
  activation_code: string;
  activation_link: string;
};
export type MindbodyIssueTokenOutSchema = {
  success?: boolean;
  message?: string | null;
  token_issued: boolean;
};
export type LocationOutSchema = {
  success?: boolean;
  message?: string | null;
  location: LocationSchema;
};
export type CreateLocationInSchema = {
  business_id: string;
  name: string;
  region: string;
  timezone: string;
  shifts?: {
    [key: string]: any;
  } | null;
};
export type TimezonesOutSchema = {
  success?: boolean;
  message?: string | null;
  timezones: [string, string][];
};
export type UpdateLocationInSchema = {
  name?: string | null;
  timezone?: string | null;
  region?: string | null;
  shifts?: {
    [key: string]: any;
  } | null;
};
export type ListConnectionsOutSchema = {
  success?: boolean;
  message?: string | null;
  connections: ConnectionSchema[];
};
export type ListIntegrationsOutSchema = {
  success?: boolean;
  message?: string | null;
  integrations: IntegrationSchema[];
};
export type LocationAccessLevelSchema = {
  user_id: string;
  user_email: string;
  location_name: string;
  access_level_name: string;
};
export type LocationAccessLevelOutSchema = {
  success?: boolean;
  message?: string | null;
  location_access_level: LocationAccessLevelSchema;
};
export type CreateLocationAccessLevelInSchema = {
  user_email: string;
  access_level_name: string;
  cascade_to_children?: boolean;
};
export type ListLocationAccessLevelsOutSchema = {
  success?: boolean;
  message?: string | null;
  location_access_levels: LocationAccessLevelSchema[];
};
export type UpdateLocationAccessLevelInSchema = {
  access_level_name: string;
  cascade_to_children?: boolean;
};
export type MetricEventSchema = {
  id: string;
  location_id: string;
  camera_id: string;
  metric_type: string;
  timestamp: string;
  value: number;
  event_data?: object;
};
export type StatsSchema = {
  totalCount: number;
  average: number | null;
  min: number | null;
  max: number | null;
};
export type AggregateMetricEventsOutSchema = {
  success?: boolean;
  message?: string | null;
  events: MetricEventSchema[];
  count: number;
  stats: StatsSchema;
  start_datetime: string;
  end_datetime: string;
};
export type MetricTypeSchema = {
  type: string;
  label: string;
  unit: string;
};
export type MetricTypesOutSchema = {
  success?: boolean;
  message?: string | null;
  metric_types: MetricTypeSchema[];
};
export type OnboardingAnalyticsOutSchema = {
  success?: boolean;
  message?: string;
};
export type OnboardingAnalyticsInSchema = {
  event_type: string;
  timestamp: string;
  video_system?: string | null;
  business_type?: string | null;
  country?: string | null;
  state?: string | null;
  interest_reasons?: string[] | null;
  location_count?: number | null;
  camera_count?: number | null;
  waitlist_reason?: string | null;
  last_step?: string | null;
  form_data?: {
    [key: string]: any;
  } | null;
  additional_data?: {
    [key: string]: any;
  } | null;
};
export type CreateSearchOutSchema = {
  success?: boolean;
  message?: string | null;
  search_id: string;
};
export type ToastRowIdentifier = {
  order_guid: string;
  business_date: string;
};
export type MindbodyRowIdentifier = {
  visit_row: string;
  business_date: string;
};
export type MindbodyWebhookIdentifier = {
  message_id: string;
  event_id: string;
  event_timestamp: string;
};
export type IntegrationContext = {
  integration_id: string;
  row_identifier:
    | ToastRowIdentifier
    | MindbodyRowIdentifier
    | MindbodyWebhookIdentifier;
  integration_data?: {
    [key: string]: any;
  } | null;
};
export type CreateSearchSchema = {
  camera_ids?: string[] | null;
  object_id?: string | null;
  search_type?: string;
  query?: string | null;
  start_time: string;
  end_time: string;
  timezone?: string | null;
  camera_zones?: CameraZone[] | null;
  schedule_id?: string | null;
  integration_context?: IntegrationContext | null;
  disable_notifications?: boolean;
  notification_type?: string | null;
  notification_emails?: string[] | null;
  use_progressive_streaming?: boolean;
};
export type SearchTypesOutSchema = {
  search_types: [string, string][];
};
export type SearchOutSchema = {
  success?: boolean;
  message?: string | null;
  search: SearchSchema;
};
export type UpdateSearchSchema = {
  disable_notifications?: boolean | null;
  notification_type?: string | null;
  notification_emails?: string[] | null;
};
export type CameraSummaryItem = {
  count: number;
  camera_id: string;
};
export type CameraSummaryOutSchema = {
  success?: boolean;
  message?: string | null;
  cameras: {
    [key: string]: CameraSummaryItem;
  };
};
export type Review = "PENDING" | "APPROVED" | "REJECTED";
export type SearchResultSchema = {
  id: string;
  camera_id: string;
  parent_result_id?: string | null;
  linked_result_ids?: string[];
  video_uri: string;
  review: Review;
  timestamp?: number;
  description?: string;
  start_time: string;
  end_time: string;
  bounding_box_start?: object;
  bounding_box_end?: object;
};
export type ResultGroup = {
  result: SearchResultSchema;
};
export type CameraResultsOutSchema = {
  success?: boolean;
  message?: string | null;
  camera_name: string;
  results: ResultGroup[];
};
export type FlatResultItem = {
  result_id: string;
  video_uri: string;
  review: string;
};
export type FlatResultsListOutSchema = {
  success?: boolean;
  message?: string | null;
  results: FlatResultItem[];
};
export type CompleteSearchInSchema = {
  status: string;
  message: string;
};
export type ListSearchOutSchema = {
  success?: boolean;
  message?: string | null;
  searches: SearchSchema[];
};
export type ResultClipInSchema = {
  uri: string;
};
export type BoundingBoxSchema = {
  x_min: number;
  x_max: number;
  y_min: number;
  y_max: number;
};
export type ResultInSchema = {
  event_start_time_epoch: number;
  event_end_time_epoch: number;
  clip_start_offset_seconds: number;
  clip_end_offset_seconds: number;
  description: string;
  clip: ResultClipInSchema;
  bounding_box_start?: BoundingBoxSchema | null;
  bounding_box_end?: BoundingBoxSchema | null;
};
export type AddResultsInSchema = {
  camera_id: string;
  orig_start_time: number;
  orig_end_time: number;
  results: ResultInSchema[];
};
export type ReviewInSchema = {
  review: Review;
};
export type UpdateResultClipInSchema = {
  uri: string;
  detection_time_stamp: number;
};
export type SearchResultsOutSchema = {
  success?: boolean;
  message?: string | null;
  results: {
    [key: string]: ResultGroup[];
  };
};
export type CreateScheduledSearchOutSchema = {
  success?: boolean;
  message?: string | null;
  scheduled_search_id: string;
};
export type CreateScheduledSearchSchema = {
  name: string;
  description?: string;
  search_camera_ids: string[];
  search_customer_query: string;
  search_camera_zones?: CameraZone[] | null;
  search_start_date_ui: string;
  search_start_time_ui: string;
  search_end_date_ui: string;
  search_end_time_ui: string;
  search_timezone?: string | null;
  frequency_type: string;
  days_of_week?: string[] | null;
  days_of_month?: number[] | null;
  location_id: string;
  search_disable_notifications?: boolean;
  search_notification_type?: string | null;
  search_notification_emails?: string[] | null;
};
export type ScheduleDataSchema = {
  frequency_type: string;
  days_of_week: string[] | null;
  days_of_month: number[] | null;
  time_str: string;
};
export type ScheduledSearchSchema = {
  id: string;
  camera_names: string[];
  search_camera_ids: string[];
  is_active: boolean;
  location_id: string;
  business_id: string;
  schedule_data: ScheduleDataSchema;
  search_camera_zones: CameraZone[] | null;
  search_notification_type_name: string | null;
  search_notification_emails: string[];
  name: string;
  description?: string | null;
  search_customer_query: string;
  search_start_time: string;
  search_end_time: string;
  schedule_expression: string;
  status?: string;
  scheduler_arn?: string | null;
  created_at: string;
  updated_at: string;
};
export type ListScheduledSearchesOutSchema = {
  success?: boolean;
  message?: string | null;
  scheduled_searches: ScheduledSearchSchema[];
  total: number;
};
export type ScheduledSearchOutSchema = {
  success?: boolean;
  message?: string | null;
  scheduled_search: ScheduledSearchSchema;
};
export type UpdateScheduledSearchSchema = {
  name?: string | null;
  description?: string | null;
  search_camera_ids?: string[] | null;
  search_customer_query?: string | null;
  search_camera_zones?: CameraZone[] | null;
  search_start_date_ui?: string | null;
  search_start_time_ui?: string | null;
  search_end_date_ui?: string | null;
  search_end_time_ui?: string | null;
  frequency_type?: string | null;
  days_of_week?: string[] | null;
  days_of_month?: number[] | null;
  search_disable_notifications?: boolean | null;
  search_notification_type?: string | null;
  search_notification_emails?: string[] | null;
};
export type ObjectTypesOutSchema = {
  success?: boolean;
  message?: string | null;
  object_types: [string, string][];
};
export type FindObjectInSchema = {
  location_id: string;
  object_type: string;
  object_name: string;
};
export type CreateObjectInSchema = {
  name: string;
  object_type: string;
  description?: string;
  location_id: string;
};
export type HlsPlaylistOutSchema = {
  success?: boolean;
  message?: string | null;
  playlist_content: string;
  playlist_start_offset?: number;
};
export type NotificationModelSchema = {
  id: string;
  notification_name: string;
  display_name: string;
  description: string;
};
export type DeliveryMethods = "EMAIL";
export type NotificationReturnSchema = {
  notification: NotificationModelSchema;
  delivery_methods: DeliveryMethods[];
  opted_in: boolean;
};
export type ListNotificationOutSchema = {
  success?: boolean;
  message?: string | null;
  notifications: NotificationReturnSchema[];
};
export type UserSchema = {
  id: string;
  default_business?: BusinessSchema | null;
  default_location?: LocationSchema | null;
  email: string;
  first_name: string;
  last_name: string;
  user_type?: string;
  notification_email?: string;
};
export type ListUsersOutSchema = {
  success?: boolean;
  message?: string | null;
  users: UserSchema[];
};
export type GetUserOutSchema = {
  success?: boolean;
  message?: string | null;
  user: UserSchema;
};
export type UpdateUserInSchema = {
  first_name?: string | null;
  last_name?: string | null;
  notification_email?: string | null;
};
export type ChangeUserNotificationSchema = {
  notification_name: string;
  delivery_method: DeliveryMethods;
};
export type CreateZendeskTicketOutSchema = {
  success?: boolean;
  message?: string | null;
  ticket_id: string;
};
export type OnboardingFormDataSchema = {
  business_type: string;
  video_system_brand: string;
  country: string;
  state: string;
  interest_reason: string[];
  number_of_locations: number;
  cameras_per_location: number;
  business_id?: string | null;
  is_smb?: boolean | null;
  selected_tier?: string | null;
};
export type CreateZendeskTicketInSchema = {
  onboarding_data: OnboardingFormDataSchema;
};
export type VipMatchSchema = {
  person_id: string;
  person_name: string;
  score: number;
};
export type DetectedFaceSchema = {
  bounding_box: {
    [key: string]: any;
  };
  confidence: number;
  vip_matches?: VipMatchSchema[];
};
export type DetectFacesOutSchema = {
  success?: boolean;
  message?: string | null;
  image_gcs_uri: string;
  faces: DetectedFaceSchema[];
};
export type PersonTagSchema = {
  name: string;
  is_system: boolean;
};
export type PersonTagsOutSchema = {
  success?: boolean;
  message?: string | null;
  tags: PersonTagSchema[];
};
export type VipPersonSchema = {
  id: string;
  location_id: string;
  name: string;
  reference_image_uri: string;
  rekognition_face_id: string | null;
  is_active: boolean;
  created_at: string;
  tags?: string[];
};
export type VipPersonOutSchema = {
  success?: boolean;
  message?: string | null;
  person: VipPersonSchema;
};
export type CreateVipPersonInSchema = {
  location_id: string;
  name: string;
  image_gcs_uri: string;
  bounding_box?: {
    [key: string]: any;
  } | null;
  review_id?: string | null;
  tags?: string[];
};
export type VipPersonWithCountSchema = {
  id: string;
  location_id: string;
  name: string;
  reference_image_uri: string;
  rekognition_face_id: string | null;
  is_active: boolean;
  created_at: string;
  tags?: string[];
  image_count?: number;
};
export type VipPersonsListOutSchema = {
  success?: boolean;
  message?: string | null;
  persons: VipPersonWithCountSchema[];
};
export type UpdateVipPersonInSchema = {
  name?: string | null;
  is_active?: boolean | null;
  tags?: string[] | null;
};
export type AddVipPersonImageInSchema = {
  image_gcs_uri: string;
  bounding_box?: {
    [key: string]: any;
  } | null;
  review_id?: string | null;
};
export type VipPersonImageSchema = {
  id: string;
  image_uri: string | null;
  created_at: string;
};
export type VipPersonImagesOutSchema = {
  success?: boolean;
  message?: string | null;
  images: VipPersonImageSchema[];
};
export type VipDetectionEventDetailSchema = {
  id: string;
  vip_person_id: string;
  vip_person_name: string;
  camera_id: string;
  camera_name: string | null;
  detection_time: string;
  confidence: number;
  bounding_box: {
    [key: string]: any;
  };
  frame_image_url: string | null;
  frame_image_uri: string | null;
  trigger_event_id: string | null;
  event_data: {
    [key: string]: any;
  };
};
export type VipDetectionsListOutSchema = {
  success?: boolean;
  message?: string | null;
  total_count: number;
  page: number;
  page_size: number;
  events: VipDetectionEventDetailSchema[];
};
export type PendingFaceReviewSchema = {
  id: string;
  face_image_url: string | null;
  face_image_uri: string;
  match_candidates: {
    [key: string]: any;
  }[];
  camera_id: string | null;
  detected_at: string;
  expires_at: string;
  face_det_score: number | null;
};
export type ReviewGroupSchema = {
  review_ids: string[];
  representative_id: string;
  match_candidates: {
    [key: string]: any;
  }[];
};
export type PendingFaceReviewsListOutSchema = {
  total_count: number;
  reviews: PendingFaceReviewSchema[];
  groups: ReviewGroupSchema[];
};
export type EnrollmentAuditRunOutSchema = {
  task_id: string;
};
export type EnrollmentAuditResultOutSchema = {
  status: string;
  result?: {
    [key: string]: any;
  } | null;
};
export type MindbodyWebhookSchema = {
  messageId: string;
  eventId: string;
  eventSchemaVersion: number;
  eventInstanceOriginationDateTime: string;
  eventData: {
    [key: string]: any;
  };
};
export type VerkadaWebhookSchema = {
  webhook_type: string;
  webhook_id: string;
  org_id: string;
  created_at: number;
  data: {
    [key: string]: any;
  };
};
export type ToastOrdersWebhookSchema = {
  timestamp: string;
  eventCategory: string;
  eventType: string;
  guid: string;
  details: {
    [key: string]: any;
  };
};
export type ToastWebhookConfigSchema = {
  shared_secret: string;
  integration_id: string;
};
export type ToastWebhookStatusSchema = {
  is_configured: boolean;
};
export const {
  useCoreViewsIndexQuery,
  useCoreViewsHealthQuery,
  useAccessLevelsViewsGetAccessLevelsQuery,
  useAutomationsViewsCreateAutomationMutation,
  useAutomationsViewsGetAutomationQuery,
  useAutomationsViewsUpdateAutomationMutation,
  useAutomationsViewsDeleteAutomationMutation,
  useBillingViewsSubscriptionCreatedEventMutation,
  useBillingViewsSubscriptionUpdatedEventMutation,
  useBillingViewsSubscriptionCancelledEventMutation,
  useBillingViewsInvoicePaymentFailedEventMutation,
  useBillingViewsInvoicePaymentSucceededEventMutation,
  useBillingViewsGetBillingStatusQuery,
  useBusinessesViewsCreateBusinessMutation,
  useBusinessesViewsListBusinessesQuery,
  useBusinessesViewsGetBusinessTypesQuery,
  useBusinessesViewsGetBusinessQuery,
  useBusinessesViewsUpdateBusinessMutation,
  useBusinessesViewsDeleteBusinessMutation,
  useBusinessesViewsGetLocationsForBusinessQuery,
  useBusinessesViewsCreateBusinessAccessLevelMutation,
  useBusinessesViewsListBusinessAccessLevelsQuery,
  useBusinessesViewsUpdateBusinessAccessLevelMutation,
  useBusinessesViewsDeleteBusinessAccessLevelMutation,
  useBusinessesViewsCreateCheckoutSessionMutation,
  useBusinessesViewsResubscribeCheckoutViewMutation,
  useBusinessesViewsManageViewMutation,
  useCamerasViewsCreateCameraMutation,
  useCamerasViewsGetCameraQuery,
  useCamerasViewsUpdateCameraMutation,
  useCamerasViewsDeleteCameraMutation,
  useCamerasViewsCreateCameraClipForCameraMutation,
  useCamerasViewsListCameraClipsForCameraQuery,
  useCamerasViewsGetCameraStreamUrlQuery,
  useCamerasViewsGenerateThumbnailForCameraMutation,
  useCamerasViewsTestPlaybackForCameraMutation,
  useCamerasViewsCreateCameraAccessLevelMutation,
  useCamerasViewsListCameraAccessLevelsQuery,
  useCamerasViewsUpdateCameraAccessLevelMutation,
  useCamerasViewsDeleteCameraAccessLevelMutation,
  useCamerasViewsCreateObjectForCameraMutation,
  useCamerasViewsListObjectsForCameraQuery,
  useCamerasViewsAddExistingObjectToCameraMutation,
  useCamerasViewsDeleteCameraObjectMappingMutation,
  useCamerasViewsUpdateCameraObjectMappingMutation,
  useConnectionsViewsCreateConnectionMutation,
  useConnectionsViewsOauthCallbackMutation,
  useConnectionsViewsGetAuthUrlQuery,
  useConnectionsViewsGetConnectionTypesQuery,
  useConnectionsViewsGetConnectionQuery,
  useConnectionsViewsUpdateConnectionMutation,
  useConnectionsViewsDeleteConnectionMutation,
  useConnectionsViewsCreateAllCamerasForConnectionMutation,
  useConnectionsViewsListCamerasByConnectionQuery,
  useIntegrationsViewsCreateIntegrationMutation,
  useIntegrationsViewsGetAuthUrlQuery,
  useIntegrationsViewsOauthCallbackMutation,
  useIntegrationsViewsGetIntegrationStatusQuery,
  useIntegrationsViewsGetIntegrationTypesQuery,
  useIntegrationsViewsGetIntegrationQuery,
  useIntegrationsViewsUpdateIntegrationConfigMutation,
  useIntegrationsViewsDeleteIntegrationMutation,
  useIntegrationsViewsProxyIntegrationRequestMutation,
  useIntegrationsViewsGetSupportedObjectTypesFromIntegrationQuery,
  useIntegrationsViewsGetSupportedEventsFromIntegrationQuery,
  useIntegrationsViewsListAutomationsForIntegrationQuery,
  useIntegrationsViewsListSearchesForIntegrationMutation,
  useIntegrationsViewsGetIntegrationMappingForSearchQuery,
  useIntegrationsViewsGetBulkSearchMappingsMutation,
  useIntegrationsViewsGetMindbodyActivationCodeQuery,
  useIntegrationsViewsMindbodyIssueTokenMutation,
  useLocationsViewsCreateLocationMutation,
  useLocationsViewsGetTimezonesQuery,
  useLocationsViewsGetLocationQuery,
  useLocationsViewsUpdateLocationMutation,
  useLocationsViewsDeleteLocationMutation,
  useLocationsViewsGetCamerasForLocationQuery,
  useLocationsViewsGetConnectionsForLocationQuery,
  useLocationsViewsGetIntegrationsForLocationQuery,
  useLocationsViewsListObjectsForLocationQuery,
  useLocationsViewsCreateLocationAccessLevelMutation,
  useLocationsViewsListLocationAccessLevelsQuery,
  useLocationsViewsUpdateLocationAccessLevelMutation,
  useLocationsViewsDeleteLocationAccessLevelMutation,
  useMetricsViewsGetMetricsForTimePeriodQuery,
  useMetricsViewsGetMetricTypesQuery,
  useMetricsViewsDeleteMetricEventMutation,
  useOnboardingViewsRecordAnalyticsEventMutation,
  useSearchesViewsCreateSearchMutation,
  useSearchesViewsGetSearchTypesQuery,
  useSearchesViewsGetSearchQuery,
  useSearchesViewsUpdateSearchMutation,
  useSearchesViewsDeleteSearchMutation,
  useSearchesViewsGetCameraSummaryQuery,
  useSearchesViewsGetCameraResultsQuery,
  useSearchesViewsGetFlatResultsListQuery,
  useSearchesViewsCompleteSearchMutation,
  useSearchesViewsListSearchesByCameraIdsQuery,
  useSearchResultsViewsAddResultsMutation,
  useSearchResultsViewsReviewResultMutation,
  useSearchResultsViewsDeleteResultMutation,
  useSearchResultsViewsUpdateResultClipUriViewMutation,
  useSearchResultsViewsUnlinkResultFromParentMutation,
  useSearchResultsViewsGetLinkedResultsQuery,
  useScheduledSearchesViewsCreateScheduledSearchApiMutation,
  useScheduledSearchesViewsListScheduledSearchesQuery,
  useScheduledSearchesViewsGetScheduledSearchQuery,
  useScheduledSearchesViewsUpdateScheduledSearchApiMutation,
  useScheduledSearchesViewsDeleteScheduledSearchApiMutation,
  useScheduledSearchesViewsPauseScheduledSearchApiMutation,
  useScheduledSearchesViewsResumeScheduledSearchApiMutation,
  useStaticObjectsViewsGetObjectTypesQuery,
  useStaticObjectsViewsFindStaticObjectViewMutation,
  useStaticObjectsViewsCreateStaticObjectViewMutation,
  useStaticObjectsViewsDeleteStaticObjectViewMutation,
  useStreamingViewsGetCameraHlsPlaylistQuery,
  useStreamingViewsGetClipHlsPlaylistQuery,
  useNotificationsViewsListNotificationsForUserQuery,
  useUsersViewsListUsersQuery,
  useUsersViewsGetCurrentUserQuery,
  useUsersViewsUpdateUserViewMutation,
  useUsersViewsOptInUserToNotificationViewMutation,
  useUsersViewsOptOutUserFromNotificationViewMutation,
  useUsersViewsCreateZendeskTicketViewMutation,
  useUsersViewsDeleteUserViewMutation,
  useVipDetectionViewsDetectFacesEndpointMutation,
  useVipDetectionViewsGetPersonTagsQuery,
  useVipDetectionViewsCreatePersonMutation,
  useVipDetectionViewsListPersonsQuery,
  useVipDetectionViewsUpdatePersonMutation,
  useVipDetectionViewsDeletePersonMutation,
  useVipDetectionViewsAddPersonImageMutation,
  useVipDetectionViewsListPersonImagesQuery,
  useVipDetectionViewsDeletePersonImageMutation,
  useVipDetectionViewsDeleteEventMutation,
  useVipDetectionViewsListDetectionsQuery,
  useVipDetectionViewsListFaceReviewsQuery,
  useVipDetectionViewsDeleteFaceReviewMutation,
  useVipDetectionViewsRunEnrollmentAuditMutation,
  useVipDetectionViewsGetEnrollmentAuditResultQuery,
  useWebhooksViewsMindbodyWebhookHeadMutation,
  useWebhooksViewsMindbodyWebhookMutation,
  useWebhooksViewsVerkadaWebhookMutation,
  useWebhooksViewsToastOrdersWebhookMutation,
  useWebhooksViewsConfigureToastWebhookMutation,
  useWebhooksViewsGetToastWebhookStatusQuery,
} = injectedRtkApi;
